import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

const resources = {
  en: {
    translation: {
      // General
      YES: 'Yes',
      NO: 'No',
      LABEL: 'Label',
      DISPLAYED: 'Displayed',
      HOME: 'Home',
      LEGAL_NOTICES: 'Legal notices',
      TERMS_OF_USE: 'Terms of use',
      FAQ: 'Frequently asked questions',
      FAQ_DESCRIPTION: 'Awaiting questions.',
      TO_SUPPORT_ME: 'Support us',
      TO_SUPPORT_ME_DESCRIPTION:
        "To support 'Rêves de Barousse', you can generate activity on social media. Share, like, comment.",
      TO_CONTACT_ME: 'Contact me',
      CONTACT_DESCRIPTION: 'You can reach me by email: ',
      COPYRIGHT:
        'Rêves de Barousse. All rights reserved. Website developed by Kubuni.',
      DETAILS: 'Details',
      SEND: 'Send',
      SEND_IN_PROGRESS: 'Sending...',
      ADD_LINK: 'Add link',
      ADD_LINKED_POI: 'Add linked POI',
      ERROR_MESSAGE: 'An error occured.',
      DEVELOPMENT_IN_PROGRESS: 'Development in progress',
      COUNTRY: 'Country',
      ZIPCODE: 'Zip code',
      PHONE: 'Phone',
      PASSWORD: 'Password',
      EMAIL_ADDRESS: 'Email address',
      ADDRESS: 'Address',
      STREET: 'Street',
      LASTNAME: 'Last name',
      FIRSTNAME: 'First name',
      CITY: 'City',
      VILLAGE: 'Village',
      SHOW: 'View',
      HIDE: 'Hide',
      CANCEL: 'Cancel',
      CONFIRM: 'Confirm',
      EDIT: 'Edit',
      SAVE: 'Save',
      MANAGE: 'Manage',
      MANAGE_EXTERNAL_LINKS: 'External links',
      MANAGE_INTERNAL_LINKS: 'Internal links',
      MANAGE_PHOTOS: 'Manage photos',
      UPDATE: 'Update',
      ADD: 'Add',
      URL: 'URL',

      // Confirm
      CONFIRM_DELETE: 'Delete Confirmation',
      CONFIRM_DELETE_MESSAGE: 'Do you want to confirm deletion?',
      COOKIE_CONSENT_MESSAGE:
        'We use cookies to enhance your experience on our site. By continuing, you agree to our use of cookies.',
      I_CONSENT: 'I consent',

      // Home
      REVES_DE_BAROUSSE_DESCRIPTION: 'Water, stone and all that lives',
      REVES_DE_BAROUSSE_DETAILS:
        "'Rêves de Barousse' opens the doors to enchantment in the heart of the Barousse Valley. Nestled in the Hautes-Pyrénées (65 - France), the Barousse is home to the watershed of the Ourse, a vital river that collects the waters of numerous streams, some of which supply drinking water to the Toulouse region. More than just a tourist initiative, 'Dreams of Barousse' aims to be a living encyclopedia of this valley, inviting you to delve into its geography, culture, and history. We embark on a complete immersion into this wild valley, where vultures and deer have taken the place of men over the decades. Welcome to this adventure where each step brings you closer to the magic and splendor of this valley",

      // Points of interest
      NO_RESULTS: 'No results for this search',
      POINTS_OF_INTEREST: 'Points of interest',
      POI_LIST_ID: 'Record No.',
      POI_LIST_TYPE_NAME: 'Type',
      POI_LIST_LABEL: 'Record',
      POI_ADD: 'Add a new point of interest',
      EVENT_ADD: 'Add a new event',

      // Page not found
      PAGE_NOT_FOUND_TITLE: 'Page Not Found',
      PAGE_NOT_FOUND_MESSAGE:
        'Sorry, the page you are looking for does not exist.',

      // Error component
      ERROR_MESSAGE_API_GET: 'An error occurred while retrieving data',
      ERROR_MESSAGE_API_POST: 'An error occurred while sending data',
      ERROR_MESSAGE_API_UPDATE: 'An error occurred while updating data',

      // Success messages
      SUCCESS_CREATED_MESSAGE: 'Creation was successful',
      SUCCESS_UPDATED_MESSAGE: 'Update was successful',
      SUCCESS_DELETED_MESSAGE: 'Deletion was successful',

      // Pending messages
      PENDING_CREATED_MESSAGE: 'Creation is being recorded',
      PENDING_UPDATED_MESSAGE: 'Update is being recorded',
      PENDING_DELETED_MESSAGE: 'Deletion is being recorded',
      PENDING_LOAD_MESSAGE: 'Loading...',

      // Point of interest
      POI_STATUS_LABEL: 'Record status',
      POI_STATUS_DRAFT: 'Draft',
      POI_STATUS_PHOTO_AND_VIDEO_AWAITING: 'Waiting for photos and video',
      POI_STATUS_VIDEO_AWAITING: 'Waiting for video',
      POI_STATUS_VIDEO_IN_PROGRESS: 'Video in progress',
      POI_STATUS_READY: 'Ready',
      POI_STATUS_DESCRIPTION_DRAFT:
        'This record is in draft. Information is being verified. Photos may not correspond.',
      POI_STATUS_DESCRIPTION_PHOTO_AND_VIDEO_AWAITING:
        'This record is awaiting photos and will soon have a video.',
      POI_STATUS_DESCRIPTION_VIDEO_AWAITING:
        'This record will soon have a video.',
      POI_STATUS_DESCRIPTION_VIDEO_IN_PROGRESS:
        'The video for this record is in progress.',
      POI_STATUS_DESCRIPTION_READY:
        'This record is considered ready. Please let me know of any errors or inaccuracies.',
      POI_TYPE_LABEL: 'Point of Interest Type',
      POI_VILLAGE_LABEL: 'Village',
      POI_CREATED_AT_LABEL: 'Creation Date',
      POI_UPDATED_AT_LABEL: 'Last Updated Date',
      SEE_ALSO: 'See also',
      SEE_ELSEWHERE: 'See elsewhere',
      SERVICES: 'Services',
      TODOS: 'To do',
      TOSEES: 'To see',
      CYCLING: 'Cycling',
      RAMPAGES: 'Rampages',
      AFFILIATE_LINKS: 'Affiliate links',
      AFFILIATE_LINKS_DESCRIPTION:
        'Affiliate links are links to business partners. If you purchase a product through this link, Reves de Barousse receive a commission. The price remains the same for the consumer.',
      COMMENTS: 'Notes and comments',
      ADD_COMMENT: 'Add a note or comment',
      NO_COMMENT_MESSAGE: 'There are no comments for this entry yet',
      COMMENT: 'Comment',
      COMMENT_PLACEHOLDER: 'Enter your comment',
      COMMENT_RATING: 'Rating',
      POST_COMMENT_SUCCESS_MESSAGE:
        'Thank you for your comment. It will be published once it has been moderated.',
      ALTITUDE_PROFILE: 'Altitude profile',

      // Photos
      SOME_PHOTOS: 'Some photos',
      PHOTO_COORDINATES: 'GPS Coordinates',
      PHOTO_RESOLUTION: 'Resolution',
      PHOTO_CAPTURED_AT: 'Captured on',
      PHOTO_CAPTURED_BY: 'Captured by',
      PHOTO_DEFINITION: 'Definition',
      MEGAPIXELS: 'megapixels',
      MAX_PRINT_SIZE: 'Max print size',
      MANUFACTURER: 'Manufacturer',
      CAMERA_MODEL: 'Camera Model',
      LENS_MAKE: 'Lens Make',
      FOCAL_LENGTH: 'Focal Length',
      APERTURE: 'Aperture',
      SHUTTER_SPEED: 'Shutter Speed',
      ISO: 'ISO',
      ALTITUDE: 'Altitude',

      // Shop
      ADD_TO_CART: 'Add to cart',
      MY_CART: 'My cart',

      // Login
      LOGIN_EMAIL: 'eMail',
      LOGIN_EMAIL_PLACEHOLDER: 'Enter email',
      LOGIN_PASSWORD: 'Password',
      LOGIN_PASSWORD_PLACEHOLDER: 'Enter password',
      LOGIN_SUBMIT: 'Login',
      LOGIN_LOGIN: 'Login',
      LOGIN_REGISTER: 'Register',
      LOGIN_INVALID_CREDENTIALS:
        'Invalid username or password. Please try again.',
      FORGOTTEN_PASSWORD_REQUEST_DESCRIPTION:
        'You will receive an email with a link to reset your password.',
      FORGOTTEN_PASSWORD_REQUEST_SUCCESS_MESSAGE:
        'You will receive an email with instructions shortly.',
      FORGOTTEN_PASSWORD_REQUEST_TITLE: 'Forgot password',
      FORGOTTEN_PASSWORD_DESCRIPTION: 'Please enter your new password.',
      FORGOTTEN_PASSWORD_SUCCESS_MESSAGE:
        'You will receive an email with instructions shortly.',
      FORGOTTEN_PASSWORD_TITLE: 'Password reset',
      PASSWORD_CHANGE_SUCCESS_MESSAGE:
        'Password has been changed successfully.',

      // Register
      REGISTER_TITLE: 'Register',
      REGISTER_SUBMIT: 'Register',
      REGISTER_ERROR_FIRSTNAME: 'Please enter your first name',
      FIRSTNAME_PLACEHOLDER: 'Enter your first name',
      REGISTER_ERROR_LASTNAME: 'Please enter your last name',
      LASTNAME_PLACEHOLDER: 'Enter your last name',
      REGISTER_ERROR_EMAIL_ADDRESS: 'Please enter your email address',
      REGISTER_ERROR_EMAIL_ADDRESS_YET_USED: 'This email is already in use',
      REGISTER_ERROR_PASSWORD:
        'At least 8 characters including at least one uppercase, one lowercase, and one special character (@,$,!,%,*,?,& or .)',
      PASSWORD_PLACEHOLDER: 'Enter a password',
      PASSWORD_PASSWORD: 'Please enter your email address',
      EMAIL_ADDRESS_PLACEHOLDER: 'Enter your email address',
      REGISTER_ERROR_PHONE: 'Please enter your phone number',
      PHONE_PLACEHOLDER: 'Enter your phone number (optional)',
      CITY_PLACEHOLDER: 'Saisir votre ville',
      ADDRESS_PLACEHOLDER: 'Saisir votre adresse',
      REGISTER_ERROR_ADDRESS: 'Veuillez saisir puis sélectionner une adresse',
      REGISTER_ERROR_STREET: 'Please enter your street address',
      STREET_PLACEHOLDER: 'Enter your street address',
      REGISTER_ERROR_ZIPCODE: 'Please enter your zip code',
      ZIPCODE_PLACEHOLDER: 'Enter your zip code',
      REGISTER_CONFIRMATION_TITLE: 'Registration Confirmation',
      REGISTER_CONFIRMATION_DESCRIPTION:
        'Thank you for signing up! A confirmation email has been sent to you. Please check your inbox and click on the confirmation link to validate your registration.',
      REGISTER_ERROR_ACTIVATING_ACCOUNT:
        'Error activating account. Please try again later.',
      REGISTER_VALIDATION_TITLE: 'Register validation',
      CAPTCHA_ERROR: 'Please check the box.',

      // Contact
      MESSAGE: 'Message',
      MESSAGE_PLACEHOLDER: 'Enter your message',
      CONTACT_ERROR_MESSAGE: 'Please enter a message (minimum 20 characters)',
      MESSAGE_SENT: 'Your message has been sent',
      SELECT_AUTOCOMPLETE_MESSAGE: 'Select an autocomplete suggestion',

      ERROR_EMPTY_COMMENT: 'Please provide a rating and/or a message',
      SUCCESS_CREATED_COMMENT:
        'Your comment has been saved and will appear once approved',
      SUCCESS_RATING: 'Your rating has been saved',

      // Events
      EVENTS: 'Events',
      START_DATE: 'Start date',
      END_DATE: 'End date',
      FROM_DATE: 'From ',
      TO_DATE: ' to ',
      FILTER_BY_DATE: 'Filter by date',
      // Poi technical sheet
      POI_TYPE_CLASSIFICATION_TITLE: 'Route Classification',
      POI_TYPE_MOUNTAIN_BIKING_PAGE_CLASSIFICATION_DESCRIPTION:
        'Classification inspired by the recommendations of the French Cycling Federation.',
      ELEVATION_GAIN_LABEL: 'Elevation gain',
      ELEVATION_LOSS_LABEL: 'Elevation loss',
      DISTANCE_LABEL: 'Distance',
      EQUIVALENT_KM_LABEL: 'Effort-km',
      TECHNICITY_LABEL: 'Technical difficulty',
      SURFACE_TYPE_LABEL: 'Trail type',
      SURFACE_LABEL: 'Territory area',
      LEVEL_LABEL: 'Classification',
      ALTITUDE_MAX_LABEL: 'Altitude max',
      ALTITUDE_LABEL: 'Altitude',
      ALTITUDE_MIN_LABEL: 'Altitude min',
      GREEN: 'Green',
      BLUE: 'Blue',
      RED: 'Red',
      BLACK: 'Black',
      EASY: 'Easy',
      MEDIUM: 'Intermediate',
      HARD: 'Hard',
      VERY_HARD: 'Very Hard',
      GRAVEL_PATH: 'Gravel Path',
      DIRT_PATH: 'Dirt Path',
      SINGLETRACK: 'Singletrack',

      // Wildlife page
      BIRD_OF_PREY: 'Bird of prey',
      BIRD: 'Bird',
      DOMESTIC_ANIMAL: 'Domestic animal',
      WILD_ANIMAL: 'Wild animal',
      INSECT: 'Insect',
      BUTTERFLY: 'Butterfly',
      INVERTEBRATE: 'Invertebrate',
      AQUATIC_ANIMAL: 'Aquatic animal',
      TYPE: 'Type',

      // Mountain bike page
      POINTS_TITLE: 'Some useful points',
      MTB_POINTS_PHYSICALLY_DEMANDING:
        'The paths of Barousse are physically demanding, electric mountain biking is often an interesting solution.',
      POINTS_RESPECT_ECOSYSTEM:
        'I respect the fragile ecosystem of the valley.',
      POINTS_RESPECT_PEOPLE: 'I respect the people of Barousse.',
      MTB_POINTS_KNOW_RULES: 'I know the rules for walkers in the pastures.',
      MTB_POINTS_PEDESTRIAN_PRIORITY:
        'I give priority to pedestrians. If I meet riders, I dismount.',
      MTB_POINTS_SAFETY_AVOID_SOLO:
        'I think about my safety, avoid riding alone, and control my speed. The mountain is hostile and a serious fall can happen quickly, even to regular practitioners, even at low speed.',
      MTB_POINTS_SAFETY_WEAR_GEAR:
        'I think about my safety, wear long gloves, a helmet. For more intense practices, I add knee pads, elbow pads, back protector, and a full-face helmet.',
      MTB_POINTS_SAFETY_PHONE:
        'I think about my safety and even though network coverage is partial in Barousse, I take my phone, fully charged, in a waterproof bag.',
      MTB_POINTS_SAFETY_AVOID_ROADS:
        'I think about my safety, avoid paved roads, Barousse has many different paths.',
      MTB_POINTS_SAFETY_AVOID_DEPARTMENTAL:
        'I think about my safety, avoid pedaling on the departmental road that leads from Sarp to Mauléon-Barousse. It is busy and accident-prone, speed limits (already too permissive) are not well respected.',
      MTB_POINTS_SAFETY_TRAIL_CONDITION:
        'I think about my safety, trails in Barousse degrade over time, sometimes dangerously. I can report any issues through the web form.',
      MTB_POINTS_SAFETY_FOREST:
        'I think about my safety, Barousse forests have been deserted over the centuries, many buildings are or will soon be in ruins, and many paths have become dead ends.',
      LESS_THAN_11KM: 'Less than 11km',
      FROM_11_TO_20KM: '11 to 20km',
      FROM_21_TO_40KM: '21 to 40km',
      MORE_THAN_40KM: 'More than 40km',
      ELEVATION_GAIN: 'Elevation Gain',
      LESS_THAN_100M: 'Less than 100m',
      FROM_101_TO_250M: '101 to 250m',
      FROM_251_TO_600M: '251 to 600m',
      MORE_THAN_600M: 'More than 600m',
      PATH_TYPE: 'Path Type',
      STABILIZED_PATH: 'Stabilized path, possibly paved',
      DIRT_OR_GRASS_PATH: 'Dirt or grass path (wide enough for a vehicle)',
      NARROW_PATH: 'Narrow path (single track)',
      TECHNIQUE: 'Technique',
      NO_SPECIAL_TECHNIQUE: 'No special technique required',
      BASIC_MOUNTAIN_BIKING_SKILLS:
        'Requires basic mountain biking skills. Presence of small obstacles, few and not very difficult (ruts, stones, wet areas) on the trail',
      ADVANCED_MOUNTAIN_BIKING_SKILLS:
        'Requires advanced mountain biking skills. Many obstacles to overcome on the trail',
      EXPERT_MOUNTAIN_BIKING_SKILLS:
        'Requires perfect mastery of all mountain biking techniques. Very demanding trail with trial zones in many sections, steep descents or ascents',
      TOTAL_POINTS: 'Total',
      TRAIL_COLOR: 'Trail Color',
      FROM_4_TO_5_POINTS: 'From 4 to 5 points',
      FROM_6_TO_8_POINTS: 'From 6 to 8 points',
      FROM_9_TO_12_POINTS: 'From 9 to 12 points',
      FROM_13_TO_15_POINTS: 'From 13 to 15 points',

      // Climbing page
      CLIMBING_POINTS_DANGER:
        'Climbing on natural sites in Barousse is a dangerous activity. For safe practice, get informed and, if necessary, be guided by qualified professionals.',

      // Hiking page
      HIKING_POINTS_PHYSICALLY_DEMANDING:
        'Some trails in Barousse are physically demanding, make sure to choose a route that matches your fitness level.',
      HIKING_POINTS_TECHNICALLY_DEMANDING:
        'Some trails in Barousse are technically demanding, make sure to choose a route that matches your technical skills.',
      HIKING_POINTS_DANGER:
        'Some trails in Barousse are dangerous and sometimes sadly fatal: rock falls, cliffs, icy snow, abysses, wild boars, bears. The mountain can be hostile, stay vigilant at all times.',
      HIKING_POINTS_PHONE:
        'Leave with your phone fully charged, even though the phone network only covers part of Barousse.',

      // Poi types pages
      POI_TYPE_ACCOMODATION_PAGE_TITLE: 'Accommodation in Barousse',
      POI_TYPE_ACCOMODATION_PAGE_DESCRIPTION:
        'The valley reveals itself over days and nights. Roosters, bells, rustling leaves, whispers of animals… and sometimes the shepherd’s whistle. You must give it time to listen — and then to understand',
      POI_TYPE_ACCOMODATION_PAGE_DETAILS:
        'To truly feel the unique and preserved atmosphere of the Barousse Valley, you need to slow down… and spend a few nights there. Then, a different side of the valley reveals itself: the nighttime sounds of owls, birds of prey, deer, and a discreet yet present wildlife. And in the early morning, it’s the roosters, church bells, and birdsong that take over.\n', // +
      //'\n' +
      //"  Here, you'll find a selection of accommodations that combine comfort, authenticity, and local commitment. Our selection is based on three main criteria:\n" +
      //'  - The property must be listed on Booking.com, allowing Rêves de Barousse to receive a commission on the booking amount. The price stays the same for you, but your stay supports us.\n' +
      //'  - An average guest rating above 8/10, as a guarantee of quality and satisfaction.\n' +
      //'  - Most importantly, a commitment to preserving and promoting the local heritage: these lodgings are often the result of passionate restorations of traditional Barousse buildings.\n' +
      //'\n' +
      //"  By choosing to stay here, you help keep the valley's nature and history alive, and inspire others to take part in restoring its fragile architectural heritage..",

      POI_TYPE_VILLAGE_PAGE_TITLE: 'The villages of Barousse',
      POI_TYPE_VILLAGE_PAGE_DETAILS:
        'The whisper of the waters mingles with the tolling of bells, the clucking of hens, the bleating of sheep, the lowing of cows, and the cry of birds of prey.\n' +
        'In this symphony, stone and timber dwellings are cradled beneath a crown of greenery.\n' +
        'Between nature and memory, these villages invite you to discover an ever-evolving heritage, sculpted by both man and the elements',
      POI_TYPE_VILLAGE_PAGE_DESCRIPTION:
        'Woven from stone and wood is the chronicle of men in symbiosis with nature—its waters, its creatures, its winter, and the wear of centuries',

      POI_TYPE_WILDLIFE_PAGE_TITLE: 'The Wildlife of Barousse',

      POI_TYPE_WILDLIFE_PAGE_DETAILS:
        'The Barousse valley opens like a discreet invitation, a threshold between the human world and wild nature.\n' +
        'In the heart of the valley, around the old stone villages, nature flourishes in all its diversity. Ancient forests stretch out their green arms, sheltering tawny owls, majestic buzzards, and red kites circling elegantly in the sky. On the meadows, sheep and horses graze peacefully, while the cheesemakers’ cows carry on a millennia-old pastoral heritage.\n' +
        'The heights of Barousse, where the air thins and silence takes its full place, harbor treasures of biodiversity: deer abound, bearded vultures soar above the cliffs of Tourroc, and sometimes the fleeting shadow of a bear crosses the steep valleys. Up there, small songbirds like the goldcrest and the coal tit enliven the undergrowth, while butterflies paint bright spots in the clearings.\n' +
        'The flowing waters of rivers and lakes welcome the trout of the Ourse, the discreet otter, and even the pyrénées’s desman, silent witnesses to a fragile balance. On the banks, the grey heron watches patiently, while swans glide majestically on the calm waters of Loures-Barousse lake.\n' +
        'Each species, from the smallest to the largest, composes the living symphony of Barousse. From the song of the thrush to the discretion of the marten, from the vigilant patrol of the livestock guardian dogs to the light steps of the dipper, this land is a world where nature dialogues with man.\n' +
        'This section invites you to meet these valley inhabitants, to understand their role, and to share their story. Because to truly embrace Barousse is also to learn to protect it, so that tomorrow these wonders will continue to resonate with the rhythm of the seasons.',

      POI_TYPE_WILDLIFE_PAGE_DESCRIPTION:
        'Knowing the ecosystem of Barousse, and particularly its rich wildlife, is the essential first step to grasp its full depth and to thoughtfully consider its future.',

      POI_TYPE_HISTORY_PAGE_TITLE: 'History of the Barousse',
      POI_TYPE_HISTORY_PAGE_DETAILS:
        'Geography made Barousse a culturally isolated valley. As a result, it has its own history, influenced by exchanges but above all by the ecosystem in which it is embedded',
      POI_TYPE_HISTORY_PAGE_DESCRIPTION:
        'Knowing and understanding the past to better interpret the present and, above all, shape the future',
      HISTORY: 'History',
      POI_TYPE_CLIMBING_PAGE_TITLE: 'Climbing in Barousse',
      POI_TYPE_CLIMBING_PAGE_DESCRIPTION:
        'The Barousse valley, with its limestone cliffs, offers many routes for all levels amid the calm of unspoiled nature.',
      POI_TYPE_CLIMBING_PAGE_DETAILS:
        'The Barousse valley, with its limestone cliffs shaped by time, is a playground for climbers. Some walls have been equipped by passionate enthusiasts, offering routes for every level. Effort blends with wonder and the serenity of preserved nature. Climb, breathe, and let yourself be captivated by the magic of rock and sky.',
      POI_TYPE_HIKING_PAGE_TITLE: 'Hiking in Barousse',
      POI_TYPE_HIKING_PAGE_DETAILS:
        'In Barousse, hiking becomes a walk between sky and earth, where every step reveals a unique panorama. The lovely summits and ridges offer exceptional balconies overlooking deep valleys and the distant plains — a true Pyrenean spectacle.\n' +
        '\n' +
        'The trails are numerous and varied, suitable for all levels, from gentle strolls to more challenging climbs. Each route is an invitation to discovery, in a preserved environment where nature reigns supreme.\n' +
        '\n' +
        'Along the way, you will come across charming villages built of stone and wood, with steadfast church steeples, old washhouses, peaceful squares, and steep narrow streets. Places where time seems suspended, and history is written on every wall.\n' +
        '\n' +
        'Here, hiking is a blend of effort and wonder, solitude and encounters, sport and contemplation. In Barousse, every trail is an open window onto the raw beauty of the Pyrenees and the soul of its villages',
      POI_TYPE_HIKING_PAGE_DESCRIPTION:
        'Discover the hiking trails in Barousse for an exceptional natural experience.',

      POI_TYPE_MOUNTAIN_BIKING_PAGE_TITLE: 'Barousse by Mountain Bike',
      POI_TYPE_MOUNTAIN_BIKING_PAGE_DETAILS:
        'La Barousse is well-suited for mountain biking. Due to the quantity and variety of available trails, away from traffic, as well as the biodiversity and the beauty of the landscapes. Here, we list some routes of varying difficulties, across almost all sectors of the valley.',
      POI_TYPE_MOUNTAIN_BIKING_PAGE_DESCRIPTION:
        'Of slopes, of water, and forgotten trails',

      POI_TYPE_PICNIC_PAGE_TITLE: 'Picnicking in Barousse',
      POI_TYPE_PICNIC_PAGE_DETAILS:
        'Here, lunch becomes a suspended moment in time. On the edge of the forest, beside a singing river, or facing the crests of the Pyrenees, Barousse offers a thousand secret spots to lay down a blanket and let time slow to a halt.\n' +
        '\n' +
        'All around you: rolling meadows, moss-covered ruins, ancient forests, and birds of prey soaring through the deep blue sky. If you’re lucky, a deer may cross your path — fleeting, silent, like a wink from the mountain.\n' +
        '\n' +
        'And in the basket? Simple, honest products from the valley. Fresh apple juice, Sost cheese, crusty bread, golden honey, and sweet treats from the Mauléon pastry chef. Every bite tells a story of the land, every flavor extends the walk.\n' +
        '\n' +
        'Whether you come as a family, a couple, or with friends, the picnic becomes a way of life — a tribute to slowness and natural beauty. In Barousse, eating outdoors means reconnecting with the essential',
      POI_TYPE_PICNIC_PAGE_DESCRIPTION:
        'Enjoy the many picnic areas in Barousse for a relaxing outdoor moment.',

      POI_TYPE_ROAD_CYCLING_PAGE_TITLE: 'Barousse by Road and Gravel Bike',
      POI_TYPE_ROAD_CYCLING_PAGE_DETAILS:
        'The Barousse valley opens to cyclists like a secret garden. From the entrance at the village of Sarp (472 m), the road winds through meadows and timeless villages. You pass through Gembrie, Mauléon-Barousse, Ferrère, and other hamlets nestled in the folds of the mountains, lulled by the song of the Ourse river. Then begins the climb to the skies: the Port de Balès (1755 m), majestic, solitary — a long ascent far from the world, surrounded by forests, streams, and often, the silent presence of deer.\n' +
        '\n' +
        'But Barousse is not only about this legendary pass. The valley is full of forgotten roads, forest trails, and small loops that are worth every pedal stroke. The Hourmigué massif, for example, offers breathtaking views of the Pic du Gar, the ridges of Gouhouroun, and the twin valleys of the Ourse de Sost and Ourse de Ferrère rivers.\n' +
        '\n' +
        'The climb up the Cols of Mortis, then Chérach, and finally the Col de la Géladiou — bordered by old quarries — presents wild challenges for those curious enough to stray off the beaten path.\n' +
        '\n' +
        'Here, there’s little traffic. Just birdsong, the wind rustling through the trees, the scent of the undergrowth, and the untouched charm of the villages. On a gravel bike, the experience becomes even more immersive, with hidden trails and adventurous descents.\n' +
        '\n' +
        'In this preserved valley, cycling becomes a way of listening, of discovery. A natural interlude — both athletic and contemplative',
      POI_TYPE_ROAD_CYCLING_PAGE_DESCRIPTION:
        'Deep forests and forgotten villages — every climb is an escape into the silence and raw beauty of the Pyrenees.',
      ROAD_CYCLING_POINTS_PHYSICALLY_DEMANDING:
        'The road and gravel cycling routes of Barousse are physically demanding, electric road bikes can often be an interesting solution.',

      UP_TO_15_EQUIVALENT_KM: 'Up to 15 effort-km',
      FROM_15_TO_30_EQUIVALENT_KM: 'From 15 to 30 effort-km',
      FROM_30_TO_60_EQUIVALENT_KM: 'From 30 to 60 effort-km',
      MORE_THAN_60_EQUIVALENT_KM: 'More than 60 effort-km',
      UP_TO_30_EQUIVALENT_KM: 'Up to 30 effort-km',
      FROM_60_TO_90_EQUIVALENT_KM: 'From 60 to 90 effort-km',
      MORE_THAN_90_EQUIVALENT_KM: 'More than 90 effort-km',

      POI_TYPE_TRAIL_PAGE_TITLE: 'Barousse Trails',
      POI_TYPE_TRAIL_PAGE_DETAILS:
        'Whether for an organized race or a solo outing, running in Barousse is a rare luxury of untouched nature. Here, trails wind through forests, meadows, and forgotten ridges, far from crowds and noise.\n' +
        '\n' +
        'Sometimes, it’s you who surprises the valley. A green woodpecker pauses its drumming, a doe freezes among the ferns, a flock watches you curiously. Vultures circle above, intrigued by your dog. Cows lift their heads, sheep calmly step aside. You are just a passing guest — discreet, panting, fleeting.\n' +
        '\n' +
        'Under your feet, the variety of terrain charms every stride: stones, damp earth, carpets of dead leaves, soft grass, or freshly fallen branches. Every step is a dialogue with the living ground.\n' +
        '\n' +
        'And then there is everything else: the strong scents of trees and mosses, heightened by recent rains. The deep sounds of the forest — cries of raptors, birdsong, ringing bells, distant lowing, or the rustle in the bushes as a deer escapes.\n' +
        '\n' +
        'Running here is more than physical effort. It is immersion, reconnection. In Barousse, trail running is a discreet art, between sky and undergrowth',
      POI_TYPE_TRAIL_PAGE_DESCRIPTION:
        'Explore the various trails in Barousse, ideal for running enthusiasts',

      POI_TYPE_RAMPAGE_PAGE_TITLE: 'Rampage in Barousse',
      POI_TYPE_RAMPAGE_PAGE_DETAILS:
        "Time passes, Barousse moves forward. Not always in the right direction, unfortunately. Modernity does not always harmonize with Barousse's heavy heritage. Sometimes we could repair. Sometimes it is too late, but let us learn the lesson to prevent future destruction. No, it wasn’t necessarily better in the past, but what was better then should be preserved, even if it sometimes means sacrificing comfort or convenience. This is the respectable work you sometimes find among the British, Italians, or Swiss, in Provence, in the Basque Country, but also sometimes in certain villages of Barousse.",
      POI_TYPE_RAMPAGE_PAGE_DESCRIPTION: 'The ravages of human folly',

      POI_TYPE_CURIOSITY_PAGE_TITLE: 'Culture and Curiosities in Barousse',
      POI_TYPE_CURIOSITY_PAGE_DETAILS:
        'Centuries of human presence, millennia for nature. A coexistence rich with varied interests. On the path that leads us from barbarism to civilization.',
      POI_TYPE_CURIOSITY_PAGE_DESCRIPTION: 'Of Nature and Humans',

      POI_TYPE_WATER_POINT_PAGE_TITLE: 'Barousse Water Points',
      POI_TYPE_WATER_POINT_PAGE_DETAILS:
        "In Barousse, water is a living presence, quiet yet vital. It springs from the rocks, sings through the ditches, and tumbles down mossy slopes. The valley glistens. Rain falls often, but it's a generous rain — one that nourishes the forests, quenches the animals, and cools the hiker’s steps.\n" +
        '\n' +
        'Some springs are born here and travel far, bringing their freshness all the way to the plains of Haute-Garonne. The mountain gives freely. In each village, there’s a fountain, a tap, a washhouse. The water is cool and clear, drawn straight from the heart of the massif.\n' +
        '\n' +
        'Walking in Barousse also means learning to lift your eyes… and lower them, to spot a trickle, hear a liquid murmur, or fill your bottle at a spring. Water is everywhere — in streams, troughs, waterfalls — a quiet thread connecting nature, animals, and people',
      POI_TYPE_WATER_POINT_PAGE_DESCRIPTION:
        'Discover the water points in Barousse, perfect for a refreshing break.',

      POPULATION: 'Population',
      POPULATION_GROWTH: 'Population Growth',
      YEAR: 'Year',

      // General
      OUR_TEAM: 'Our Team',
      TO_SUPPORT_ME_TITLE_1: 'By helping to build awareness',
      TO_SUPPORT_ME_DESCRIPTION_1:
        'This will help us increase our audience. You can use social media (shares, likes, and comments) or recommend us to your network.',
      TO_SUPPORT_ME_TITLE_2:
        'By helping us improve the quantity and quality of content',
      TO_SUPPORT_ME_DESCRIPTION_2:
        'You can comment on the records on the web platform and videos. Feel free to report errors (even a spelling mistake), outdated information, or add to the information provided. You can also suggest new records: points of interest or events.',
      TO_SUPPORT_ME_TITLE_3: 'By using the online shop',
      TO_SUPPORT_ME_DESCRIPTION_3:
        'Feel free to order from the online shop. This helps us generate revenue and thus the means to continue producing free content and fund projects in the interest of Barousse.',
      ADD_PHOTOS: 'Add photos',
      EDIT_MODE: 'Edit mode',
      SUCCESS_STATUS_UPDATED_MESSAGE: 'Status update was successful',
      PHOTO_ADDED_TO_CART_MESSAGE: 'The photograph has been added to the cart',
      PRODUCT_ADDED_TO_CART_MESSAGE: 'The product has been added to the cart',
      PENDING_CREATE_MESSAGE: 'Creation is being recorded',
      PENDING_UPDATE_MESSAGE: 'Update is being recorded',
      PENDING_DELETE_MESSAGE: 'Deletion is being recorded',
      YOUR_CART_IS_EMPTY: 'Your cart is empty',
      PROCEED_TO_CHECKOUT: 'Proceed to checkout',
      CHOOSE: 'Choose',
      ADJUST_QUANTITY: 'Adjust quantity',
      AVAILABLE_OPTIONS: 'Available options',
      SHOP: 'Shop',
      PRODUCT_SHEET: 'Product sheet',
      PRICE: 'Price',
      SHOP_DESCRIPTION: 'In support of our activity',
      SHOP_DETAILS:
        "The business model of 'Rêves de Barousse' relies largely on the revenue from the shop. It will soon offer local products related to Barousse and photography. If you have the desire and means, please consider placing an order. This allows us to continue offering free content while limiting advertising pollution.",
      POINTS_OF_INTEREST_DESCRIPTION:
        'Select the categories of points of interest',
      CATEGORIES: 'Categories',
      CATEGORY: 'Category',
      SAME_CATEGORY: 'In the same category',
      EVENTS_DESCRIPTION: 'Select the categories of events',
      PHOTO_ADDED_TO_CART: 'The photograph has been added to the cart',
      PRODUCT_ADDED_TO_CART: 'The product has been added to the cart',
      TOTAL_PRICE_WITH_SHIPPING: 'Total price',
      ORDER_INFORMATIONS: 'Order information',
      BILLING_INFORMATIONS: 'Billing information',
      SHIPPING_INFORMATIONS: 'Shipping information',
      CUSTOMER_NAME: 'Name',
      CUSTOMER_ADDRESS: 'Address',
      ORDER_SUMMARY: 'Order summary',
      ITEMS_PRICE: 'Items price',
      SHIPPING_COST: 'Shipping cost',
      TOTAL_PRICE: 'Total price',
      I_ACCEPT_TERMS_AND_CONDITIONS: 'I accept the terms and conditions',
      PLEASE_FILL_ALL_INFOS_AND_ACCEPT_TERMS:
        'Please fill in all information and accept the terms to continue.',
      PROCEED_TO_PAYMENT: 'Proceed to payment',
      FAVORITE_PLACE: 'Favorite place',
      REGISTER_ACTIVATING_SUCCESS: 'Account activated successfully!',
      REGISTER_ACTIVATING_IN_PROGRESS: 'Activating account...',
      MINIMAL_MONTH: 'Minimal month',
      MAXIMAL_MONTH: 'Maximal month',
      PHONE_LABEL: 'Phone number',
      EMAIL_LABEL: 'Email',
      POI_TYPE_HIKING_PAGE_CLASSIFICATION_DESCRIPTION:
        'The effort-kilometer is a unit that estimates the difficulty of a route by integrating both horizontal distance and positive elevation gain, adding 1 km for every 100 meters of ascent.',
      POI_TYPE_WALK_PAGE_TITLE: 'Walks in Barousse',
      POI_TYPE_WALK_PAGE_DETAILS:
        'In Barousse, every path is an invitation to wander. There’s no need to conquer peaks here — beauty lies within reach, in a sunlit meadow, a mossy forest, or a forgotten alleyway in an ancient village.\n' +
        '\n' +
        'Whether you follow the course of a river, gently climb to a small pass, or explore a hidden chapel, each walk becomes a moment of wonder. The valley is full of natural and historical points of interest: remarkable trees, old washhouses, mills, Romanesque churches, abandoned quarries, and secret viewpoints.\n' +
        '\n' +
        'The trails are short, accessible, and rich in detail. Each walk tells a story, revealed at your own pace, through birdsong, rustling leaves, and the scent of the undergrowth.\n' +
        '\n' +
        'With family, as a couple, or alone, walking in Barousse is about rediscovering the simple joy of being guided by a path — slowing down, observing. A discreet kind of luxury, in the heart of the Pyrenees',
      POI_TYPE_WALK_PAGE_DESCRIPTION:
        'We list here some short walks for outdoor outings accessible to everyone.',
      POI_TYPE_ROAD_CYCLING_PAGE_CLASSIFICATION_DESCRIPTION:
        'The effort-kilometer is a unit that estimates the difficulty of a route by integrating both horizontal distance and positive elevation gain, adding 1 km for every 200 meters of ascent.',
      POI_TYPE_TRAIL_PAGE_CLASSIFICATION_DESCRIPTION:
        'The effort-kilometer is a unit that estimates the difficulty of a route by integrating both horizontal distance and positive elevation gain, adding 1 km for every 100 meters of ascent.',
      MANAGE_TITLE: 'Admin console',
      MANAGE_CONTACTS_TITLE: 'Contact requests',
      MANAGE_COMMENTS_TITLE: 'Comment management',
      MANAGE_STATS_TITLE: 'Statistics',
      MANAGE_EXTERNAL_LINK_NEW_TITLE: 'Add an external link',
      MANAGE_EXTERNAL_LINKS_TITLE: 'External links',
      NEW: 'New',
      READ: 'Read',
      PROCESSED: 'Processed',
      ARCHIVED: 'Archived',
      VALIDATED: 'Validated',
      REJECTED: 'Rejected',
      NO_CONTACTS: 'No contact requests',
      NO_COMMENTS: 'No comments',
    },
  },
  fr: {
    translation: {
      // General
      YES: 'Oui',
      NO: 'Non',
      LABEL: 'Libellé',
      DISPLAYED: 'Affiché',
      HOME: 'Accueil',
      LEGAL_NOTICES: 'Mentions légales',
      TERMS_OF_USE: "Conditions générales d'utilisation",
      OUR_TEAM: 'Notre équipe',
      FAQ: 'Foire aux questions',
      FAQ_DESCRIPTION: 'En attente de questions.',
      TO_SUPPORT_ME: 'Nous soutenir',
      TO_SUPPORT_ME_DESCRIPTION:
        "'Rêves de Barousse' c'est une plateforme web, des photos et du contenu vidéo. Votre soutien peut nous permettre de continuer à produire du contenu gratuit et de qualité tout en limitant au possible la publicité. Vous pouvez nous soutenir de diverses façons.",
      TO_SUPPORT_ME_TITLE_1: 'En aidant au développement de la notoriété',
      TO_SUPPORT_ME_DESCRIPTION_1:
        "Cela nous permettra d'augmenter notre audience. Vous pouvez utiliser les réseaux sociaux (partages, likes et commentaires) ou nous recommander auprès de votre entourage.",
      TO_SUPPORT_ME_TITLE_2:
        'En nous aidant à améliorer la quantité et la qualité du contenu',
      TO_SUPPORT_ME_DESCRIPTION_2:
        "Vous pouvez commenter les fiches sur la plateforme web et les vidéos. N'hésitez à signaler des erreurs (même une faute d'orthographe), des obsolescences ou à compléter les informations apportées. Vous pouvez aussi nous proposer de nouvelles fiches: points d'intérêts ou événements.",
      TO_SUPPORT_ME_TITLE_3: 'En utilisant la boutique en ligne',
      TO_SUPPORT_ME_DESCRIPTION_3:
        "N'hésitez pas à commander sur la boutique en ligne. Cela nous permet de générer un chiffre d'affaire et donc des moyens pour assurer la continuité de la production de contenu et financer des projets dans l'intérêt de la Barousse.",
      TO_CONTACT_ME: 'Nous contacter',
      CONTACT_DESCRIPTION: 'Vous pouvez nous joindre par email: ',
      COPYRIGHT:
        'Rêves de Barousse. Tous droits réservés. Site développé par Kubuni',
      DETAILS: 'Détails',
      SEND: 'Envoyer',
      SEND_IN_PROGRESS: 'Envoi en cours...',
      ADD: 'Ajouter',
      ADD_LINK: 'Ajouter un lien externe',
      ADD_LINKED_POI: 'Ajouter un lien interne',
      ADD_PHOTOS: 'Ajouter des photos',
      EDIT: 'Mettre à jour',
      SAVE: 'Enregistrer',
      UPDATE: 'Mettre à jour',
      SHOW: 'Voir',
      HIDE: 'Masquer',
      CANCEL: 'Annuler',
      CONFIRM: 'Confirmer',
      EDIT_MODE: 'Mode édition',
      ERROR_MESSAGE: "Une erreur s'est produite.",
      DEVELOPMENT_IN_PROGRESS: 'Développement en cours',
      COUNTRY: 'Pays',
      ZIPCODE: 'Code postal',
      PHONE: 'Téléphone',
      PASSWORD: 'Mot de passe',
      EMAIL_ADDRESS: 'e-Mail',
      ADDRESS: 'Adresse',
      STREET: 'Adresse',
      LASTNAME: 'Nom',
      FIRSTNAME: 'Prénom',
      CITY: 'Ville',
      VILLAGE: 'Village',
      URL: 'URL',

      // Confirm
      CONFIRM_DELETE: 'Confirmation de suppression',
      CONFIRM_DELETE_MESSAGE: 'Souhaitez-vous confirmez la suppression ?',
      COOKIE_CONSENT_MESSAGE:
        'Nous utilisons des cookies pour améliorer votre expérience sur notre site. En continuant, vous acceptez notre utilisation des cookies.',
      I_CONSENT: "J'accepte",

      // Home
      REVES_DE_BAROUSSE_DESCRIPTION: "L'eau, la pierre et le vivant",
      REVES_DE_BAROUSSE_DETAILS:
        "'Rêves de Barousse' vous ouvre les portes de l'enchantement au cœur de la vallée de la Barousse. Nichée dans les Hautes-Pyrénées, la Barousse abrite le bassin versant de l'Ourse, une rivière vitale qui recueille les eaux de nombreux ruisseaux, dont certains alimentant la région toulousaine en eau potable. Bien plus qu'une initiative touristique, 'Rêves de Barousse' se veut surtout une encyclopédie vivante de cette vallée, vous invitant à plonger dans sa géographie, sa culture et son histoire. Nous partons alors pour une immersion complète dans cette vallée sauvage, où les vautours et les cervidés ont pris la place des hommes au fil des décennies. Bienvenue  donc dans cette aventure où chaque pas vous rapproche de la magie et de la splendeur de cette vallée",

      // Page not found
      PAGE_NOT_FOUND_TITLE: 'Page non trouvée',
      PAGE_NOT_FOUND_MESSAGE: "Désolé, la page recherchée n'existe pas.",

      // Error component
      ERROR_MESSAGE_API_GET:
        "Une erreur s'est produite lors de la récupération des données",
      ERROR_MESSAGE_API_POST:
        "Une erreur s'est produite lors de l'envoi des données",
      ERROR_MESSAGE_API_UPDATE:
        "Une erreur s'est produite lors de la mise à jour des données",

      // Success messages
      SUCCESS_CREATED_MESSAGE: "La création s'est effectuée avec succès",
      SUCCESS_UPDATED_MESSAGE: "La mise à jour s'est effectuée avec succès",
      SUCCESS_STATUS_UPDATED_MESSAGE:
        "La mise à jour du statut s'est effectuée avec succès",
      SUCCESS_DELETED_MESSAGE: "La suppression s'est effectuée avec succès",
      PHOTO_ADDED_TO_CART_MESSAGE: 'La photographie a été ajoutée au panier',
      PRODUCT_ADDED_TO_CART_MESSAGE: 'Le produit a été ajouté au panier',

      // Pending message
      PENDING_CREATE_MESSAGE: "La création est en cours d'enregistrement",
      PENDING_UPDATE_MESSAGE: "La mise à jour est en cours d'enregistrement",
      PENDING_DELETE_MESSAGE: "La suppression est en cours d'enregistrement",
      PENDING_LOAD_MESSAGE: 'Chargement en cours ...',

      // Points of interest
      NO_RESULTS: 'Aucun résultat pour cette recherche',
      POINTS_OF_INTEREST: "Points d'intérêt",
      POI_LIST_ID: 'Fiche n°',
      POI_LIST_TYPE_NAME: 'Type',
      POI_LIST_LABEL: 'Fiche',
      POI_ADD: "Ajouter un nouveau point d'intérêt",
      EVENT_ADD: 'Ajouter un nouvel événement',

      // Point of interest
      POI_STATUS_LABEL: 'État de la fiche',
      POI_STATUS_DRAFT: 'En préparation',
      POI_STATUS_PHOTO_AND_VIDEO_AWAITING:
        'En attente de photos et de la vidéo',
      POI_STATUS_VIDEO_AWAITING: 'En attente de la vidéo',
      POI_STATUS_VIDEO_IN_PROGRESS: 'Vidéo en cours de préparation',
      POI_STATUS_READY: 'Terminée',
      POI_STATUS_DESCRIPTION_DRAFT:
        'Cette fiche est en préparation. Les informations sont en cours de vérification. Les photos peuvent ne pas correspondre.',
      POI_STATUS_DESCRIPTION_PHOTO_AND_VIDEO_AWAITING:
        "Cette fiche est en attente de photos et fera prochainement l'objet d'une vidéo.",
      POI_STATUS_DESCRIPTION_VIDEO_AWAITING:
        "Cette fiche fera prochainement l'objet d'une vidéo.",
      POI_STATUS_DESCRIPTION_VIDEO_IN_PROGRESS:
        'La vidéo pour cette fiche est en cours de réalisation.',
      POI_STATUS_DESCRIPTION_READY:
        "Cette fiche est considérée terminée. N'hésitez pas à nous signaler d'éventuelles erreurs ou imprécisions.",
      POI_TYPE_LABEL: 'Type',
      POI_VILLAGE_LABEL: 'Village',
      POI_CREATED_AT_LABEL: 'Création',
      POI_UPDATED_AT_LABEL: 'Dernière mise à jour',
      SEE_ALSO: 'Voir aussi',
      SERVICES: 'Services',
      TODOS: 'À faire',
      TOSEES: 'À voir',
      CYCLING: 'Pédaler',
      RAMPAGES: 'Saccages',
      SEE_ELSEWHERE: 'Voir par ailleurs',
      AFFILIATE_LINKS: 'Liens affiliés',
      AFFILIATE_LINK: 'Lien affilié',
      AFFILIATE_LINKS_DESCRIPTION:
        'Les liens affiliés sont des liens vers des partenaires commerciaux. Si vous achetez un produit en passant par ce lien, Rêves de Barousse perçoit une commission, pour vous le prix reste le même.',
      COMMENTS: 'Notes et commentaires',
      ADD_COMMENT: 'Ajouter une note ou un commentaire',
      NO_COMMENT_MESSAGE:
        "Il n'y a pas encore de commentaires pour cette fiche",
      COMMENT: 'Commentaire',
      COMMENT_PLACEHOLDER: 'Saisir votre commentaire',
      COMMENT_RATING: 'Note',
      POST_COMMENT_SUCCESS_MESSAGE:
        'Merci pour votre commentaire. Il sera publié dès la validation par la modération.',
      ALTITUDE_PROFILE: 'Profil altimétrique',

      // Photo
      SOME_PHOTOS: 'Quelques photos',
      PHOTO_COORDINATES: 'Coordonnées GPS',
      PHOTO_RESOLUTION: 'Résolution',
      PHOTO_CAPTURED_AT: 'Prise le',
      PHOTO_CAPTURED_BY: 'Prise par',
      MEGAPIXELS: 'mégapixels',
      MANUFACTURER: 'Fabricant',
      CAMERA_MODEL: 'Appareil photo',
      LENS_MAKE: 'Objectif',
      FOCAL_LENGTH: 'Focale',
      APERTURE: 'Ouverture',
      SHUTTER_SPEED: 'Vitesse',
      ISO: 'ISO',
      ALTITUDE: 'Altitude',
      PHOTO_DEFINITION: 'Définition',
      MAX_PRINT_SIZE: 'Impression maxi',

      // Shop
      ADD_TO_CART: 'Ajouter au panier',
      MY_CART: 'Mon panier',
      YOUR_CART_IS_EMPTY: 'Votre panier est vide',
      PROCEED_TO_CHECKOUT: 'Valider ma commande',
      CHOOSE: 'Choisir',
      ADJUST_QUANTITY: 'Ajuster la quantité',
      AVAILABLE_OPTIONS: 'Options disponibles',
      SHOP: 'La boutique',
      PRODUCT_SHEET: 'Fiche produit',
      PRICE: 'Prix',
      SHOP_DESCRIPTION: 'Au soutien de notre activité',
      SHOP_DETAILS:
        "Le modèle économique de 'Rêves de Barousse' repose en grande partie sur les revenus de la boutique. Celle-ci proposera prochainement des produits locaux autour de la Barousse et de la photographie. Si vous en avez l'envie et les capacités, n'hésitez donc pas à passer commande. Cela nous permet de continuer à proposer du contenu gratuit tout en limitant les pollutions publicitaires.",
      POINTS_OF_INTEREST_DESCRIPTION:
        'Sélectionnez les catégories de points d’intérêt',
      CATEGORIES: 'Catégories',
      CATEGORY: 'Catégorie',
      SAME_CATEGORY: 'Dans la même catégorie',
      EVENTS_DESCRIPTION: 'Sélectionnez les catégories d’évènements',
      PHOTO_ADDED_TO_CART: 'La photographie a été ajoutée au panier',
      PRODUCT_ADDED_TO_CART: 'Le produit a été ajouté au panier',
      TOTAL_PRICE_WITH_SHIPPING: 'Prix total',
      ORDER_INFORMATIONS: 'Informations de commande',
      BILLING_INFORMATIONS: 'Informations de facturation',
      SHIPPING_INFORMATIONS: 'Informations de livraison',
      CUSTOMER_NAME: 'Nom',
      CUSTOMER_ADDRESS: 'Adresse',
      ORDER_SUMMARY: 'Récapitulatif de la commande',
      ITEMS_PRICE: 'Montant des articles',
      SHIPPING_COST: 'Frais de livraison',
      TOTAL_PRICE: 'Prix total',
      I_ACCEPT_TERMS_AND_CONDITIONS:
        "J'accepte les conditions générales de vente",
      PLEASE_FILL_ALL_INFOS_AND_ACCEPT_TERMS:
        'Veuillez remplir toutes les informations et accepter les conditions pour continuer.',
      PROCEED_TO_PAYMENT: 'Procéder au paiement',

      // Our team
      FAVORITE_PLACE: 'Lieu préféré',

      // Login
      LOGIN_EMAIL: 'Email',
      LOGIN_EMAIL_PLACEHOLDER: 'Saisir votre email',
      LOGIN_PASSWORD: 'Mot de passe',
      LOGIN_PASSWORD_PLACEHOLDER: 'Saisir votre mot de passe',
      LOGIN_LOGIN: 'Se connecter',
      LOGIN_REGISTER: "S'inscrire",
      LOGIN_INVALID_CREDENTIALS:
        "Nom d'utilisateur ou mot de passe incorrect. Veuillez réessayer.",
      FORGOTTEN_PASSWORD_REQUEST_DESCRIPTION:
        'Vous recevrez un email avec un lien pour réinitialiser votre mot de passe.',
      FORGOTTEN_PASSWORD_REQUEST_SUCCESS_MESSAGE:
        'Vous recevrez un email avec les instructions dans quelques instants.',
      FORGOTTEN_PASSWORD_REQUEST_TITLE: 'Mot de passe oublié',
      FORGOTTEN_PASSWORD_DESCRIPTION:
        'Veuillez saisir votre nouveau mot de passe.',
      FORGOTTEN_PASSWORD_SUCCESS_MESSAGE:
        'Vous recevrez un email avec les instructions dans quelques instants.',
      FORGOTTEN_PASSWORD_TITLE: 'Réinitialisation du mot de passe',
      PASSWORD_CHANGE_SUCCESS_MESSAGE:
        'Le mot de passe a été changé avec succès.',

      // Register
      REGISTER_TITLE: "S'inscrire",
      REGISTER_SUBMIT: "S'inscrire",
      REGISTER_ERROR_FIRSTNAME: 'Veuillez saisir votre prénom',
      FIRSTNAME_PLACEHOLDER: 'Saisir votre prénom',
      REGISTER_ERROR_LASTNAME: 'Veuillez saisir votre nom',
      LASTNAME_PLACEHOLDER: 'Saisir votre nom',
      REGISTER_ERROR_EMAIL_ADDRESS: 'Veuillez saisir votre e-mail',
      REGISTER_ERROR_EMAIL_ADDRESS_YET_USED: 'Cet email est déjà utilisé',
      REGISTER_ERROR_PASSWORD:
        'Au moins 8 caractères dont au moins une majuscule, une minuscule et un caractère spécial (@,$,!,%,*,?,& ou .)',
      PASSWORD_PLACEHOLDER: 'Entrer un mot de passe',
      REGISTER_ERROR_PHONE: 'Veuillez saisir votre numéro de téléphone',
      EMAIL_ADDRESS_PLACEHOLDER: 'Saisir votre e-mail',
      PHONE_PLACEHOLDER: 'Saisir votre téléphone (facultatif)',
      CITY_PLACEHOLDER: 'Saisir votre ville',
      ADDRESS_PLACEHOLDER: 'Saisir votre adresse',
      REGISTER_ERROR_ADDRESS: 'Veuillez saisir puis sélectionner une adresse',
      REGISTER_ERROR_STREET: 'Veuillez saisir votre adresse',
      STREET_PLACEHOLDER: 'Saisir votre adresse',
      REGISTER_ERROR_ZIPCODE: 'Veuillez saisir votre code postal',
      ZIPCODE_PLACEHOLDER: 'Saisir votre code postal',
      REGISTER_CONFIRMATION_TITLE: "Confirmation d'inscription",
      REGISTER_CONFIRMATION_DESCRIPTION:
        'Merci pour votre inscription ! Un email de confirmation vient de vous être envoyé. Veuillez vérifier votre boîte de réception et cliquer sur le lien de confirmation pour valider votre inscription.',
      REGISTER_ERROR_ACTIVATING_ACCOUNT:
        "Erreur lors de l'activation du compte. Veuillez réessayer plus tard.",
      REGISTER_ACTIVATING_SUCCESS: 'Compte activé avec succès !',
      REGISTER_ACTIVATING_IN_PROGRESS: 'Activation du compte en cours...',
      REGISTER_VALIDATION_TITLE: "Validation de l'inscription",
      CAPTCHA_ERROR: 'Veuillez cocher la case.',

      // Contact
      MESSAGE: 'Message',
      MESSAGE_PLACEHOLDER: 'Saisir votre message',
      CONTACT_ERROR_MESSAGE:
        'Veuillez saisir un message (20 caractères minimum)',
      ERROR_EMPTY_COMMENT: 'Veuillez saisir une note et/ou un message',
      SUCCESS_CREATED_COMMENT:
        'Votre commentaire a été enregistré et apparaîtra dès sa validation',
      SUCCESS_RATING: 'Votre note a été enregistré',
      MESSAGE_SENT: 'Votre message a été envoyé',
      SELECT_AUTOCOMPLETE_MESSAGE:
        "Sélectionner une suggestion d'autocomplétion",

      // Events
      EVENTS: 'Évènements',
      START_DATE: 'Date de début',
      END_DATE: 'Date de fin',
      MINIMAL_MONTH: 'Mois minimal',
      MAXIMAL_MONTH: 'Mois maximal',
      FROM_DATE: 'Du ',
      TO_DATE: ' au ',
      FILTER_BY_DATE: 'Filtrer par date',

      // Riding
      ELEVATION_GAIN_LABEL: 'Dénivelé positif',
      ELEVATION_LOSS_LABEL: 'Dénivelé négatif',
      DISTANCE_LABEL: 'Distance',
      EQUIVALENT_KM_LABEL: 'Km-efforts',
      TECHNICITY_LABEL: 'Difficulté technique',
      SURFACE_TYPE_LABEL: 'Type de terrain',
      SURFACE_LABEL: 'Superficie',
      PHONE_LABEL: 'Numéro de téléphone',
      EMAIL_LABEL: 'Courrier électronique',
      LEVEL_LABEL: 'Classification',
      ALTITUDE_LABEL: 'Altitude',
      ALTITUDE_MAX_LABEL: 'Altitude Max',
      ALTITUDE_MIN_LABEL: 'Altitude Min',
      GREEN: 'Vert',
      BLUE: 'Bleu',
      RED: 'Rouge',
      BLACK: 'Noir',
      EASY: 'Facile',
      MEDIUM: 'Intermédiaire',
      HARD: 'Difficile',
      VERY_HARD: 'Très difficile',
      GRAVEL_PATH: 'Piste bitumée ou stabilisée',
      DIRT_PATH: 'Piste en terre ou herbe',
      SINGLETRACK: 'Sentier',

      // Wildlife type
      BIRD_OF_PREY: 'Rapace',
      BIRD: 'Oiseau',
      DOMESTIC_ANIMAL: 'Animal domestique',
      WILD_ANIMAL: 'Animal sauvage',
      INSECT: 'Insecte',
      BUTTERFLY: 'Papillon',
      INVERTEBRATE: 'Invertébré',
      AQUATIC_ANIMAL: 'Animal aquatique',
      TYPE: 'Type',

      // Mountain bike page
      POINTS_TITLE: 'Quelques points utiles',
      MTB_POINTS_PHYSICALLY_DEMANDING:
        'Les chemins de Barousse sont physiquement exigeants, le VTT à assistance électrique est une solution souvent intéressante.',
      POINTS_RESPECT_ECOSYSTEM:
        'Je respecte le fragile écosystème de la vallée.',
      POINTS_RESPECT_PEOPLE: 'Je respecte les gens de Barousse.',
      MTB_POINTS_KNOW_RULES:
        'Je connais les règles des promeneurs dans les estives.',
      MTB_POINTS_PEDESTRIAN_PRIORITY:
        'Je laisse la priorité aux piétons. Si je croise des cavaliers, je mets pied à terre.',
      MTB_POINTS_SAFETY_AVOID_SOLO:
        "Je pense à ma sécurité, j'évite de rouler seul et je contrôle ma vitesse. La montagne est hostile et une grave chute est vite arrivée, même aux pratiquants réguliers, même à basse vitesse.",
      MTB_POINTS_SAFETY_WEAR_GEAR:
        'Je pense à ma sécurité, je porte des gants longs, un casque. Pour des pratiques engagées je complète avec genouillères, coudières, dorsale et casque intégral.',
      MTB_POINTS_SAFETY_PHONE:
        "Je pense à ma sécurité et même si la couverture réseau n'est que partielle en Barousse, je prends mon téléphone, chargé à 100%, dans un sac étanche.",
      MTB_POINTS_SAFETY_AVOID_ROADS:
        "Je pense à ma sécurité, j'évite tant que possible les routes bitumées, la Barousse regorge de chemins de tous types.",
      MTB_POINTS_SAFETY_AVOID_DEPARTMENTAL:
        "Je pense à ma sécurité, j'évite de pédaler sur la départementale qui mène de Sarp à Mauléon-Barousse. Celle-ci est fréquentée et accidentogène, les limitations de vitesse (déjà trop permissives) ne sont pas bien respectées.",
      MTB_POINTS_SAFETY_TRAIL_CONDITION:
        'Je pense à ma sécurité, les chemins de Barousse se dégradent au fil du temps, parfois dangereusement. Je peux remonter tout problème par un signalement sur la fiche web.',
      MTB_POINTS_SAFETY_FOREST:
        "Je pense à ma sécurité, les forêts de Barousse ont été désertées au fil des siècles, beaucoup de bâtisses sont ou seront très bientôt à l'état de ruine, mais surtout beaucoup de chemins se sont transformés en impasse.",
      LESS_THAN_11KM: '- de 11km',
      FROM_11_TO_20KM: '11 à 20km',
      FROM_21_TO_40KM: '21 à 40km',
      MORE_THAN_40KM: '+ de 40km',
      ELEVATION_GAIN: 'Dénivelé positif',
      LESS_THAN_100M: '- de 100m',
      FROM_101_TO_250M: 'de 101 à 250m',
      FROM_251_TO_600M: 'De 251 à 600m',
      MORE_THAN_600M: '+ de 600m',
      PATH_TYPE: 'Type de voie',
      STABILIZED_PATH: 'Voie/piste en stabilisé pouvant être goudronnée',
      DIRT_OR_GRASS_PATH:
        "Piste en terre ou en herbe (voie assez large permettant le passage d'un véhicule)",
      NARROW_PATH: 'Sentier ou voie étroite (monotrace)',
      TECHNIQUE: 'Technique',
      NO_SPECIAL_TECHNIQUE:
        'Progression ne nécessitant aucune technique particulière',
      BASIC_MOUNTAIN_BIKING_SKILLS:
        'Progression nécessitant un premier niveau de pilotage VTT. Présence de petits obstacles, peu nombreux, sans réelles difficultés (ornières, pierres, zones humides) sur le parcours',
      ADVANCED_MOUNTAIN_BIKING_SKILLS:
        'Progression nécessitant des qualités techniques avérées de pilotage VTT. Nombreux obstacles à franchir sur le parcours',
      EXPERT_MOUNTAIN_BIKING_SKILLS:
        'Progression nécessitant une parfaite maîtrise de toutes les techniques de pilotage VTT. Parcours très exigeant avec des zones trialisantes sur de nombreux secteurs du parcours, descentes ou montées raides',
      TOTAL_POINTS: 'Total',
      TRAIL_COLOR: 'Couleur du parcours',
      FROM_4_TO_5_POINTS: 'De 4 à 5 points',
      FROM_6_TO_8_POINTS: 'De 6 à 8 points',
      FROM_9_TO_12_POINTS: 'De 9 à 12 points',
      FROM_13_TO_15_POINTS: 'De 13 à 15 points',

      // Climbing page
      CLIMBING_POINTS_DANGER:
        "L'escalade sur site naturel en Barousse est une activité dangereuse. Pour pratiquer en toute sécurité, renseignez-vous et, si nécessaire, faites-vous encadrer par des professionnels qualifiés.",

      // Hiking page
      HIKING_POINTS_PHYSICALLY_DEMANDING:
        'Certains chemins de Barousse sont physiquement exigeants, veillez à choisir un parcours adapté à votre niveau de forme.',
      HIKING_POINTS_TECHNICALLY_DEMANDING:
        'Certains chemins de Barousse sont techniques, veillez à choisir un parcours adapté à votre niveau technique.',
      HIKING_POINTS_DANGER:
        'Certains chemins de Barousse sont dangereux et parfois hélas mortels: chutes de pierre, falaises, neige glacée, gouffres, sangliers, ours. La montagne ets parfois hostile, restez vigilants en continu.',
      HIKING_POINTS_PHONE:
        "Partez avec votre téléphone chargé à 100%, même si le réseau téléphonique ne couvre qu'une partie de la Barousse",
      POI_TYPE_HIKING_PAGE_CLASSIFICATION_DESCRIPTION:
        "Le kilomètre-effort est une unité qui permet d'estimer la difficulté d'un parcours en intégrant à la fois la distance horizontale et le dénivelé positif, en ajoutant 1 km pour chaque 100 mètres de montée.",
      UP_TO_15_EQUIVALENT_KM: "Jusqu'à 15 km-efforts",
      FROM_15_TO_30_EQUIVALENT_KM: 'De 15 à 30 km-efforts',
      FROM_30_TO_60_EQUIVALENT_KM: 'De 30 à 60 km-efforts',
      MORE_THAN_60_EQUIVALENT_KM: '+ de 60 km-efforts',
      UP_TO_30_EQUIVALENT_KM: "Jusqu'à 30 km-efforts",
      FROM_60_TO_90_EQUIVALENT_KM: 'De 60 à 90 km-efforts',
      MORE_THAN_90_EQUIVALENT_KM: '+ de 90 km-efforts',

      // Poi types pages
      POI_TYPE_CLASSIFICATION_TITLE: 'Classification des parcours',
      POI_TYPE_MOUNTAIN_BIKING_PAGE_CLASSIFICATION_DESCRIPTION:
        'Classification inspirée des recommandations de la Fédération Française de Cyclisme.',

      POI_TYPE_WALK_PAGE_TITLE: 'Balades en Barousse',
      POI_TYPE_WALK_PAGE_DETAILS:
        'En Barousse, chaque sentier est une invitation à la flânerie. Ici, nul besoin de partir à l’assaut des sommets : la beauté se trouve à portée de pas, dans une prairie ensoleillée, une forêt tapissée de mousse ou une ruelle oubliée d’un village ancien.\n' +
        '\n' +
        'Qu’on suive le cours d’une rivière, qu’on grimpe doucement jusqu’à un petit col, ou qu’on explore une chapelle cachée, la balade devient un prétexte à l’émerveillement. La vallée regorge de points d’intérêt naturels ou historiques : arbres remarquables, lavoirs, moulins, églises romanes, carrières oubliées, points de vue secrets...\n' +
        '\n' +
        'Les sentiers sont courts, accessibles, et riches de détails. Chaque balade est une histoire à découvrir, à son rythme, au fil du chant des oiseaux, du bruissement des feuilles, du parfum des sous-bois.\n' +
        '\n' +
        'En famille, en couple ou en solo, marcher en Barousse, c’est retrouver le plaisir simple de se laisser porter par un chemin, de ralentir, d’observer. Un luxe discret, au cœur des Pyrénées.',
      POI_TYPE_WALK_PAGE_DESCRIPTION:
        'Nous recensons là quelques courtes balades pour des sorties en plein air accessibles à tous.',

      POI_TYPE_ACCOMODATION_PAGE_TITLE: 'Hébergements en Barousse',
      POI_TYPE_ACCOMODATION_PAGE_DESCRIPTION:
        'La vallée se découvre au fil des jours et des nuits. Coqs, cloches, feuillages, murmures animaux… et parfois le sifflet du berger. Il faut lui donner du temps pour l’écouter, puis la comprendre.',
      POI_TYPE_ACCOMODATION_PAGE_DETAILS:
        'Pour vraiment ressentir l’atmosphère unique et préservée de la vallée de Barousse, il faut prendre le temps… et s’y attarder quelques nuits. C’est une autre vallée qui se dévoile alors : celle des sons nocturnes, des chouettes, des rapaces, des cervidés, et de toute une faune discrète mais présente. Puis, au petit matin, ce sont les coqs, les cloches et les oiseaux qui prennent le relais.', // Ici donc une sélection d\'hébergements qui allient confort, authenticité et engagement local. Trois critères ont guidé notre choix: - Une présence sur Booking.com, permettant à "Rêves de Barousse" de recevoir une commission sur le montant de votre réservation. Le prix reste le même pour vous, mais votre séjour nous soutient. - Une note moyenne supérieure à 8/10, gage de qualité et de satisfaction. - Et surtout, une implication dans la préservation du patrimoine et une volonté de la promouvoir: ces logements sont souvent le fruit de rénovations passionnées de bâtisses typiques de la Barousse. En choisissant de dormir ici, vous participez à faire vivre ce territoire, sa nature et son histoire et à motiver d\'éventuels amateurs de rénovation du fragile patrimoine architectural de la vallée.',

      POI_TYPE_VILLAGE_PAGE_TITLE: 'Les villages de Barousse',
      POI_TYPE_VILLAGE_PAGE_DETAILS:
        'Le murmure des flots de la rivière se mêle au carillon des cloches, aux caquètements, aux bêlements, aux meuglements et au cri des rapaces.\n' +
        'Dans cette symphonie, des habitations de pierre et de bois se dorlotent sous une couronne de verdure.\n' +
        'Entre nature et mémoire, ces villages vous invitent à découvrir un héritage toujours en mouvement, façonné par les hommes et les éléments',
      POI_TYPE_VILLAGE_PAGE_DESCRIPTION:
        "De pierre et de bois se tisse la chronique d’hommes en symbiose avec la nature, ses eaux, ses créatures, son hiver et l'usure des siècles.",

      POI_TYPE_WILDLIFE_PAGE_TITLE: 'La faune de Barousse',
      POI_TYPE_WILDLIFE_PAGE_DETAILS:
        'La Barousse s’ouvre comme une invitation discrète, un seuil entre monde humain et nature sauvage. \n' +
        'Au cœur de la vallée, autour des vieux villages de pierre, la nature s’épanouit dans toute sa diversité. Les forêts anciennes étendent leurs bras verts, refuge de chouettes hulottes, de busards en majesté et de milans royaux qui tournent en cercles élégants dans le ciel. Sur les prairies, les brebis et les chevaux paissent paisiblement, tandis que les vaches des fromagers perpétuent un héritage pastoral millénaire.\n' +
        'Les hauteurs de la Barousse, où l’air se raréfie et le silence prend toute sa place, abritent des trésors de biodiversité : les cervidés foisonnent, les gypaètes barbus planent sur les falaises du Tourroc, et, parfois, l’ombre furtive d’un ours traverse les vallons escarpés. Là-haut, les petits passereaux comme le roitelet ou la mésange charbonnière animent les sous-bois tandis que les papillons colorent de taches vives les clairières.\n' +
        'Les eaux vives des rivières et lacs accueillent la truite de l’Ourse, la loutre discrète, et même le desman des Pyrénées, témoins silencieux d’un équilibre fragile. Sur les berges, le héron cendré veille patiemment, tandis que les cygnes glissent avec majesté sur les eaux calmes du lac de Loures-Barousse.\n' +
        'Chaque espèce, des plus petites aux plus imposantes, compose la symphonie vivante de la Barousse. Du chant des grives à la discrétion de la martre, de la patrouille vigilante des patous aux pas légers du cincle plongeur, ce territoire est un monde où la nature dialogue avec l’homme.\n' +
        'Cette rubrique vous invite à rencontrer ces habitants de la vallée, à comprendre leur rôle et à partager leur histoire. Car s’imprégner de la Barousse, c’est aussi apprendre à la protéger, pour que demain encore, ces merveilles continuent de vibrer au rythme des saisons',
      POI_TYPE_WILDLIFE_PAGE_DESCRIPTION:
        'Connaître l’écosystème de la Barousse, et en particulier sa richesse animale, est le premier pas essentiel pour en saisir toute la profondeur et penser son avenir.',

      POI_TYPE_HISTORY_PAGE_TITLE: 'Histoire de la Barousse',
      POI_TYPE_HISTORY_PAGE_DETAILS:
        "La géographie a fait de la Barousse une vallée isolée sur le plan culturel. En conséquence elle possède sa propre histoire, influencée par les échanges mais surtout par l'écosystème dans lequel elle s'intègre",
      POI_TYPE_HISTORY_PAGE_DESCRIPTION:
        'Connaître et comprendre le passé, pour mieux lire le présent et surtout dessiner le futur',
      HISTORY: 'Histoire',
      POI_TYPE_CLIMBING_PAGE_TITLE: 'Escalade en Barousse',
      POI_TYPE_CLIMBING_PAGE_DESCRIPTION:
        'La Barousse, vallée calcaire aux falaises sculptées, propose de nombreuses voies pour tous les niveaux au calme de la nature préservée.',
      POI_TYPE_CLIMBING_PAGE_DETAILS:
        'La Barousse est un espace naturel idéal pour les grimpeurs. Certaines parois ont été équipées par des passionnés, offrant des voies pour tous les niveaux. L’effort se mêle à l’émerveillement, escaladez, respirez, et laissez-vous séduire par la magie des roches et du ciel.',
      POI_TYPE_HIKING_PAGE_TITLE: 'Randonner en Barousse',
      POI_TYPE_HIKING_PAGE_DETAILS:
        'En Barousse, la randonnée devient une promenade entre ciel et terre, où chaque pas dévoile un panorama unique. Les jolis sommets et crêtes offrent des balcons exceptionnels sur les vallées profondes et la plaine lointaine, un véritable spectacle pyrénéen.\n' +
        '\n' +
        'Les sentiers sont nombreux et variés, adaptés à tous les niveaux, des balades douces aux montées plus exigeantes. Chaque itinéraire est une invitation à la découverte, dans un environnement préservé où la nature règne en maître.\n' +
        '\n' +
        'Au fil du chemin, vous croiserez des villages charmants, bâtis en pierre et bois, au clocher fidèle, aux lavoirs d’antan, aux places paisibles et ruelles escarpées. Des lieux où le temps semble suspendu, où l’histoire se lit sur chaque mur.\n' +
        '\n' +
        'Ici, randonner c’est allier effort et émerveillement, solitude et rencontres, sport et contemplation. En Barousse, chaque sentier est une fenêtre ouverte sur la beauté brute des Pyrénées et l’âme de ses villages',
      POI_TYPE_HIKING_PAGE_DESCRIPTION:
        'Partez à la découverte des sentiers de randonnée en Barousse pour une expérience naturelle exceptionnelle.',

      POI_TYPE_MOUNTAIN_BIKING_PAGE_TITLE: 'La Barousse à VTT',
      POI_TYPE_MOUNTAIN_BIKING_PAGE_DETAILS:
        "La Barousse se prête bien à la pratique du VTT. Par la quantité et la variété de chemins disponibles, à l'écart de la circulation ainsi que par la biodiversité et la beauté des paysages. Nous recensons ici quelques parcours de difficultés diverses, sur un peu tous les secteurs de la vallée",
      POI_TYPE_MOUNTAIN_BIKING_PAGE_DESCRIPTION:
        'De la pente, de l’eau et des chemins oubliés',

      POI_TYPE_PICNIC_PAGE_TITLE: 'Pique-nique en Barousse',
      POI_TYPE_PICNIC_PAGE_DETAILS:
        'Ici, la pause déjeuner devient un instant suspendu. En lisière de forêt, au bord d’une rivière chantante ou face aux crêtes des Pyrénées, la Barousse offre mille recoins secrets pour étendre une nappe et laisser le temps s’arrêter.\n' +
        '\n' +
        'Autour de vous : prairies ondoyantes, ruines couvertes de mousse, forêts centenaires et vols de rapaces dans le ciel bleu profond. Si vous êtes chanceux, un cerf ou une biche croisera votre regard — furtif, silencieux, comme un clin d’œil de la montagne.\n' +
        '\n' +
        'Et dans le panier ? Des produits de la vallée, simples et vrais. Un jus de pomme frais, du fromage de Sost, un pain croustillant, du miel doré et quelques douceurs sucrées du pâtissier de Mauléon. Chaque bouchée raconte un terroir, chaque saveur prolonge la promenade.\n' +
        '\n' +
        'Qu’on vienne en famille, en couple ou entre amis, le pique-nique devient un art de vivre, un hommage à la lenteur et à la beauté naturelle. En Barousse, manger dehors, c’est renouer avec l’essentiel',
      POI_TYPE_PICNIC_PAGE_DESCRIPTION:
        'Profitez des nombreux espaces de pique-nique en Barousse pour un moment de détente en plein air.',

      POI_TYPE_ROAD_CYCLING_PAGE_TITLE: 'La Barousse à vélo de route et gravel',
      POI_TYPE_ROAD_CYCLING_PAGE_DETAILS:
        'La vallée de Barousse s’ouvre aux cyclistes comme un jardin secret. Dès l’entrée au village de Sarp (472 m), la route serpente entre prairies et villages d’un autre temps. On traverse Gembrie,  Mauléon-Barousse, Ferrère, et d’autres villages blottis dans les plis de la montagne, bercés par le chant de l’Ourse. Puis vient la montée vers les cieux : le port de Balès (1755 m), majestueux, solitaire, des kilomètres d’ascension loin du monde, entourés de forêts, de ruisseaux, et souvent, du passage silencieux des cerfs.\n' +
        '\n' +
        'Mais la Barousse ne se résume pas à ce col mythique. La vallée regorge de routes oubliées, de chemins forestiers et de petites boucles qui valent chaque coup de pédale. Le massif du Hourmigué, par exemple, offre des panoramas saisissants sur le pic du Gar, les crêtes du Gouhouroun, et les vallées jumelles des rivières Ourse de Sost et Ourse de Ferrère.\n' +
        '\n' +
        'Le montée des cols de Mortis puis de Chérach puis du le col de la Géladiou, bordée d’anciennes carrières, réservent des défis sauvages aux curieux qui aiment sortir des sentiers battus.\n' +
        '\n' +
        'Dans cette vallée, peu de circulation. Juste le chant des oiseaux, le souffle du vent dans les branches, le parfum des sous-bois et le charme intact des villages. En gravel, l’expérience devient encore plus immersive, entre sentiers cachés et descentes aventureuses.\n' +
        '\n' +
        'Dans cette vallée préservée, le vélo devient un moyen d’écoute et de découverte. Une parenthèse naturelle, à la fois sportive et contemplative',
      POI_TYPE_ROAD_CYCLING_PAGE_DESCRIPTION:
        'Forêts profondes et villages oubliés, chaque montée est une échappée vers le silence et la beauté brute des Pyrénées.',
      ROAD_CYCLING_POINTS_PHYSICALLY_DEMANDING:
        'Les itinéraires de cyclisme sur route et gravel en Barousse sont physiquement exigeants, les vélos de route électriques peuvent souvent être une solution intéressante.',

      POI_TYPE_ROAD_CYCLING_PAGE_CLASSIFICATION_DESCRIPTION:
        "Le kilomètre-effort est une unité qui permet d'estimer la difficulté d'un parcours en intégrant à la fois la distance horizontale et le dénivelé positif, en ajoutant 1 km pour chaque 200 mètres de montée.",
      POI_TYPE_TRAIL_PAGE_CLASSIFICATION_DESCRIPTION:
        "Le kilomètre-effort est une unité qui permet d'estimer la difficulté d'un parcours en intégrant à la fois la distance horizontale et le dénivelé positif, en ajoutant 1 km pour chaque 100 mètres de montée.",
      POI_TYPE_TRAIL_PAGE_TITLE: 'Trails de Barousse',
      POI_TYPE_TRAIL_PAGE_DETAILS:
        'Qu’on vienne pour une compétition encadrée ou pour une sortie solitaire, courir en Barousse, c’est s’offrir le luxe rare d’une nature intacte. Ici, les sentiers serpentent à travers forêts, prairies et crêtes oubliées, loin de la foule et du bruit.\n' +
        '\n' +
        'Parfois, c’est vous qui surprenez la vallée. Un pic vert s’interrompt en plein tambourinage, une biche se fige dans les fougères, un troupeau vous observe, curieux. Les vautours tournoient au-dessus, intrigués par votre chien. Les vaches lèvent la tête, les moutons s’écartent calmement. Vous n’êtes qu’un invité de passage, discret, haletant, éphémère.\n' +
        '\n' +
        'Sous vos pieds, la diversité des sols fait le charme de chaque foulée : pierres, terre humide, tapis de feuilles mortes, herbe souple ou branches fraîchement tombées. Chaque appui est un dialogue avec le sol vivant.\n' +
        '\n' +
        'Et puis il y a le reste : les odeurs puissantes des arbres et des mousses, réveillées par les pluies récentes. Les bruits profonds de la forêt — cris de rapaces, chants d’oiseaux, tintements des cloches, beuglements lointains, ou ce frisson dans les fourrés quand un cerf s’échappe.\n' +
        '\n' +
        'Courir ici, c’est plus qu’un effort physique. C’est une immersion, une reconnexion. En Barousse, le trail est un art discret, entre ciel et sous-bois',
      POI_TYPE_TRAIL_PAGE_DESCRIPTION:
        'Explorez les différents trails de la Barousse, parfaits pour les amateurs de course à pied.',

      POI_TYPE_RAMPAGE_PAGE_TITLE: 'Saccage Barousse',
      POI_TYPE_RAMPAGE_PAGE_DETAILS:
        "Le temps passe, la Barousse avance. Pas toujours vers la bonne direction hélas. La modernité ne va pas toujours en harmonie avec le lourd héritage de la Barousse. Parfois on pourrait réparer. Parfois il est trop tard mais retenons la leçon pour se prémunir de futurs saccages. Non ce n'était pas nécessairement mieux avant, mais ce qui était mieux avant il est souhaitable de le protéger, quitte parfois à perdre en confort/commodité. C'est le travail respectable que l'on trouve parfois chez les britanniques, les italiens ou les suisses, en Provence, au Pays Basque mais aussi dans certains villages de Barousse",
      POI_TYPE_RAMPAGE_PAGE_DESCRIPTION: 'Les ravages de la folie des hommes',

      POI_TYPE_CURIOSITY_PAGE_TITLE: 'Culture et curiosités en Barousse',
      POI_TYPE_CURIOSITY_PAGE_DETAILS:
        "Des siècles de présence pour l'homme, des millénaires pour la nature. Une cohabitation riche d'intérêts variés. De quoi s'émerveiller mais aussi réfléchir, pour un tourisme qui nous mène sur le chemin de la barbarie vers la civilisation.",
      POI_TYPE_CURIOSITY_PAGE_DESCRIPTION: 'De la nature et des hommes',

      POI_TYPE_WATER_POINT_PAGE_TITLE: "Les points d'eau de Barousse",
      POI_TYPE_WATER_POINT_PAGE_DETAILS:
        'En Barousse, l’eau est une présence vivante, discrète et essentielle. Elle sourd des roches, chante dans les rigoles, cascade sur les pentes moussues. La vallée ruisselle. Il y pleut souvent, mais c’est une pluie bienfaisante, celle qui nourrit les forêts, abreuve les bêtes, et rafraîchit les pas du voyageur.\n' +
        '\n' +
        'Certaines sources naissent ici pour aller, bien plus loin, désaltérer les plaines de Haute-Garonne. La montagne donne sans compter. Dans chaque village, une fontaine, un robinet, un lavoir. On y boit une eau fraîche et claire, venue tout droit des entrailles du massif.\n' +
        '\n' +
        'Marcher en Barousse, c’est aussi apprendre à lever les yeux… et à baisser la tête, pour repérer un filet d’eau, écouter un murmure liquide, remplir sa gourde à la source. L’eau est partout — dans les ruisseaux, les abreuvoirs, les cascades — comme un fil invisible qui relie la nature, les bêtes et les hommes',
      POI_TYPE_WATER_POINT_PAGE_DESCRIPTION:
        "Découvrez les points d'eau de la Barousse, parfaits pour une pause rafraîchissante.",

      POPULATION: 'Population',
      POPULATION_GROWTH: 'Évolution de la population',
      YEAR: 'Année',

      // Admin page
      MANAGE: 'Gérer',
      MANAGE_EXTERNAL_LINKS: 'Gestion des liens externes',
      MANAGE_INTERNAL_LINKS: 'Gestion des liens internes',
      MANAGE_PHOTOS: 'Gérer les photos',
      MANAGE_TITLE: 'Console admin',
      MANAGE_CONTACTS_TITLE: 'Demandes de contact',
      MANAGE_COMMENTS_TITLE: 'Gestion des commentaires',
      MANAGE_STATS_TITLE: 'Statistiques',
      MANAGE_EXTERNAL_LINK_NEW_TITLE: 'Ajouter un lien externe',
      MANAGE_EXTERNAL_LINKS_TITLE: 'Liens externes',
      NEW: 'Nouveau',
      READ: 'Lu',
      PROCESSED: 'Traité',
      ARCHIVED: 'Archivé',
      VALIDATED: 'Validé',
      REJECTED: 'Rejeté',
      NO_CONTACTS: 'Pas de demandes de contact',
      NO_COMMENTS: 'Pas de commentaires',
    },
  },
  es: {
    translation: {
      // General
      OUR_TEAM: 'Nuestro equipo',
      TO_SUPPORT_ME_TITLE_1: 'Ayudando a aumentar la notoriedad',
      TO_SUPPORT_ME_DESCRIPTION_1:
        'Esto nos permitirá aumentar nuestra audiencia. Puedes usar las redes sociales (compartir, dar me gusta, comentar) o recomendarnos a tu entorno.',
      TO_SUPPORT_ME_TITLE_2:
        'Ayudándonos a mejorar la cantidad y calidad del contenido',
      TO_SUPPORT_ME_DESCRIPTION_2:
        'Puedes comentar las fichas en la plataforma web y los videos. No dudes en señalar errores (incluso una falta de ortografía), información obsoleta o complementar la información proporcionada. También puedes proponer nuevas fichas: puntos de interés o eventos.',
      TO_SUPPORT_ME_TITLE_3: 'Utilizando la tienda en línea',
      TO_SUPPORT_ME_DESCRIPTION_3:
        'No dudes en hacer pedidos en la tienda en línea. Esto nos permite generar ingresos y, por lo tanto, los medios para continuar produciendo contenido gratuito y financiar proyectos en beneficio de Barousse.',
      EDIT_MODE: 'Modo de edición',
      HIDE: 'Ocultar',
      SUCCESS_STATUS_UPDATED_MESSAGE:
        'La actualización del estado se realizó con éxito',
      PHOTO_ADDED_TO_CART_MESSAGE: 'La fotografía ha sido añadida al carrito',
      PRODUCT_ADDED_TO_CART_MESSAGE: 'El producto ha sido añadido al carrito',
      PENDING_CREATE_MESSAGE: 'La creación está siendo registrada',
      PENDING_UPDATE_MESSAGE: 'La actualización está siendo registrada',
      PENDING_DELETE_MESSAGE: 'La eliminación está siendo registrada',
      YOUR_CART_IS_EMPTY: 'Tu carrito está vacío',
      PROCEED_TO_CHECKOUT: 'Proceder al pago',
      CHOOSE: 'Elegir',
      ADJUST_QUANTITY: 'Ajustar cantidad',
      AVAILABLE_OPTIONS: 'Opciones disponibles',
      SHOP: 'Tienda',
      PRODUCT_SHEET: 'Ficha de producto',
      PRICE: 'Precio',
      SHOP_DESCRIPTION: '',
      SHOP_DETAILS:
        "El modelo económico de 'Rêves de Barousse' se basa en gran parte en los ingresos de la tienda. Pronto ofrecerá productos locales relacionados con Barousse y la fotografía. Si tienes la posibilidad y las ganas, no dudes en hacer un pedido. Esto nos permite seguir ofreciendo contenido gratuito mientras limitamos la contaminación publicitaria.",
      POINTS_OF_INTEREST_DESCRIPTION:
        'Selecciona las categorías de puntos de interés',
      CATEGORIES: 'Ccategorías',
      CATEGORY: 'Ccategoría',
      SAME_CATEGORY: 'En la misma categoría',
      EVENTS_DESCRIPTION: 'Selecciona las categorías de eventos',
      PHOTO_ADDED_TO_CART: 'La fotografía ha sido añadida al carrito',
      PRODUCT_ADDED_TO_CART: 'El producto ha sido añadido al carrito',
      TOTAL_PRICE_WITH_SHIPPING: 'Precio total',
      ORDER_INFORMATIONS: 'Información del pedido',
      BILLING_INFORMATIONS: 'Información de facturación',
      SHIPPING_INFORMATIONS: 'Información de envío',
      CUSTOMER_NAME: 'Nombre',
      CUSTOMER_ADDRESS: 'Dirección',
      ORDER_SUMMARY: 'Resumen del pedido',
      ITEMS_PRICE: 'Precio de los artículos',
      SHIPPING_COST: 'Costos de envío',
      TOTAL_PRICE: 'Precio total',
      I_ACCEPT_TERMS_AND_CONDITIONS: 'Acepto los términos y condiciones',
      PLEASE_FILL_ALL_INFOS_AND_ACCEPT_TERMS:
        'Por favor, completa toda la información y acepta los términos para continuar.',
      PROCEED_TO_PAYMENT: 'Proceder al pago',
      FAVORITE_PLACE: 'Lugar favorito',
      MINIMAL_MONTH: 'Mes mínimo',
      MAXIMAL_MONTH: 'Mes máximo',
      PHONE_LABEL: 'Número de teléfono',
      EMAIL_LABEL: 'Correo electrónico',
      POI_TYPE_HIKING_PAGE_CLASSIFICATION_DESCRIPTION:
        'El kilómetro-esfuerzo es una unidad que estima la dificultad de una ruta integrando tanto la distancia horizontal como la ganancia de elevación positiva, añadiendo 1 km por cada 100 metros de ascenso.',
      POI_TYPE_WALK_PAGE_TITLE: 'Paseos en Barousse',
      POI_TYPE_WALK_PAGE_DETAILS:
        'En Barousse, cada sendero es una invitación al paseo. No hace falta conquistar cumbres — la belleza está al alcance del paso, en un prado bañado de sol, un bosque cubierto de musgo o una callejuela olvidada de un antiguo pueblo.\n' +
        '\n' +
        'Ya sea siguiendo el curso de un río, subiendo suavemente hasta un pequeño collado o explorando una capilla escondida, cada paseo se convierte en un momento de asombro. El valle está lleno de lugares de interés natural o histórico: árboles singulares, lavaderos, molinos, iglesias románicas, canteras olvidadas y miradores secretos.\n' +
        '\n' +
        'Los senderos son cortos, accesibles y ricos en detalles. Cada paseo es una historia que se descubre al ritmo de cada uno, entre cantos de pájaros, susurros de hojas y aromas del sotobosque.\n' +
        '\n' +
        'En familia, en pareja o en solitario, caminar por la Barousse es reencontrarse con el placer sencillo de dejarse llevar por un camino, de frenar el paso, de observar. Un lujo discreto, en el corazón de los Pirineos',
      POI_TYPE_WALK_PAGE_DESCRIPTION:
        'Aquí recopilamos algunos paseos cortos para salidas al aire libre accesibles para todos.',
      POI_TYPE_ROAD_CYCLING_PAGE_CLASSIFICATION_DESCRIPTION:
        'El kilómetro-esfuerzo es una unidad que estima la dificultad de una ruta integrando tanto la distancia horizontal como la ganancia de elevación positiva, añadiendo 1 km por cada 200 metros de ascenso.',
      POI_TYPE_TRAIL_PAGE_CLASSIFICATION_DESCRIPTION:
        'El kilómetro-esfuerzo es una unidad que estima la dificultad de una ruta integrando tanto la distancia horizontal como la ganancia de elevación positiva, añadiendo 1 km por cada 100 metros de ascenso.',
      MANAGE_TITLE: 'Consola de administración',
      MANAGE_CONTACTS_TITLE: 'Solicitudes de contacto',
      MANAGE_COMMENTS_TITLE: 'Gestión de comentarios',
      MANAGE_STATS_TITLE: 'Estadísticas',
      MANAGE_EXTERNAL_LINK_NEW_TITLE: 'Agregar un enlace externo',
      MANAGE_EXTERNAL_LINKS_TITLE: 'Enlaces externos',
      NEW: 'Nuevo',
      READ: 'Leído',
      PROCESSED: 'Procesado',
      ARCHIVED: 'Archivado',
      VALIDATED: 'Validado',
      REJECTED: 'Rechazado',
      NO_CONTACTS: 'No hay solicitudes de contacto',
      NO_COMMENTS: 'No hay comentarios',

      // General
      YES: 'Si',
      NO: 'No',
      LABEL: 'Etiqueta',
      DISPLAYED: 'Mostrado',
      HOME: 'Inicio',
      LEGAL_NOTICES: 'Avisos Legales',
      TERMS_OF_USE: 'Términos de Uso',
      FAQ: 'Preguntas Frecuentes',
      FAQ_DESCRIPTION: 'Esperando preguntas.',
      TO_SUPPORT_ME: 'Para apoyarnos',
      TO_SUPPORT_ME_DESCRIPTION:
        "Para apoyar 'Rêves de Barousse', puedes generar actividad en las redes sociales.",
      TO_CONTACT_ME: 'Contactar conmigo',
      CONTACT_DESCRIPTION: 'Puede contactarme por correo electrónico: ',
      COPYRIGHT:
        'Rêves de Barousse. Todos los derechos reservados. Sitio desarrollado por Kubuni.',
      DETAILS: 'Detalles',
      SEND: 'Enviar',
      SEND_IN_PROGRESS: 'Enviando...',
      CANCEL: 'Cancelar',
      CONFIRM: 'Confirmar',
      SHOW: 'Ver',
      EDIT: 'Editar',
      MANAGE: 'Gestionar',
      MANAGE_EXTERNAL_LINKS: 'Enlaces externos',
      MANAGE_INTERNAL_LINKS: 'Enlaces internos',
      MANAGE_PHOTOS: 'Gestionar fotos',
      SAVE: 'Guardar',
      UPDATE: 'Actualizar',
      ADD: 'Añadir',
      ADD_LINK: 'Agregar un enlace',
      ADD_LINKED_POI: 'Agregar un POI relacionado',
      ADD_PHOTOS: 'Agregar fotos',
      ERROR_MESSAGE: 'Ha ocurrido un error.',
      DEVELOPMENT_IN_PROGRESS: 'Desarrollo en curso',
      COUNTRY: 'País',
      ZIPCODE: 'Código postal',
      PHONE: 'Teléfono',
      EMAIL_ADDRESS: 'Correo electrónico',
      PASSWORD: 'Contraseña',
      ADDRESS: 'Dirección',
      STREET: 'Calle',
      LASTNAME: 'Apellido',
      FIRSTNAME: 'Nombre',
      CITY: 'City',
      VILLAGE: 'Village',
      URL: 'URL',

      // Confirm
      CONFIRM_DELETE: 'Confirmación de eliminación',
      CONFIRM_DELETE_MESSAGE: '¿Desea confirmar la eliminación?',
      COOKIE_CONSENT_MESSAGE:
        'Utilizamos cookies para mejorar su experiencia en nuestro sitio. Al continuar, acepta nuestro uso de cookies.',
      I_CONSENT: 'Consiento',

      // Home
      REVES_DE_BAROUSSE_DESCRIPTION: 'El agua, la piedra y la vida',
      REVES_DE_BAROUSSE_DETAILS:
        "'Rêves de Barousse' abre las puertas al encanto en el corazón del Valle de Barousse. Anidado en los Hautes-Pyrénées (65 - Francia), el Barousse alberga la cuenca hidrográfica del Ourse, un río vital que recoge las aguas de numerosos arroyos, algunos de los cuales abastecen de agua potable a la región de Toulouse. Más que una simple iniciativa turística, 'Rêves de Barousse' pretende ser una enciclopedia viviente de este valle, invitándote a sumergirte en su geografía, cultura e historia. Nos embarcamos en una inmersión completa en este valle salvaje, donde los buitres y los ciervos han tomado el lugar de los hombres a lo largo de las décadas. Bienvenidos a esta aventura donde cada paso te acerca a la magia y esplendor de este valle.",

      // Page not found
      PAGE_NOT_FOUND_TITLE: 'Página no encontrada',
      PAGE_NOT_FOUND_MESSAGE: 'Lo siento, la página que buscas no existe.',

      // Error component
      ERROR_MESSAGE_API_GET: 'Se ha producido un error al recuperar los datos',
      ERROR_MESSAGE_API_POST: 'Se ha producido un error al enviar los datos',
      ERROR_MESSAGE_API_UPDATE:
        'Se ha producido un error al actualizar los datos',

      // Success messages
      SUCCESS_CREATED_MESSAGE: 'La creación se realizó con éxito',
      SUCCESS_UPDATED_MESSAGE: 'La actualización se realizó con éxito',
      SUCCESS_DELETED_MESSAGE: 'La eliminación se realizó con éxito',

      // Pending messages
      PENDING_CREATED_MESSAGE: 'Creation is being recorded',
      PENDING_UPDATED_MESSAGE: 'Update is being recorded',
      PENDING_DELETED_MESSAGE: 'Deletion is being recorded',
      PENDING_LOAD_MESSAGE: 'Cargando...',

      // Points of interests
      NO_RESULTS: 'No hay resultados para esta búsqueda',
      POINTS_OF_INTEREST: 'Puntos de interés',
      POI_LIST_ID: 'Número',
      POI_LIST_TYPE_NAME: 'Tipo',
      POI_LIST_LABEL: 'Registro',
      POI_ADD: 'Agregar un nuevo punto de interés',
      EVENT_ADD: 'Agregar un nuevo evento',

      // Point of interest
      POI_STATUS_LABEL: 'Estado de la ficha',
      POI_STATUS_DRAFT: 'En preparación',
      POI_STATUS_PHOTO_AND_VIDEO_AWAITING: 'Esperando fotos y video',
      POI_STATUS_VIDEO_AWAITING: 'Esperando el video',
      POI_STATUS_VIDEO_IN_PROGRESS: 'Video en progreso',
      POI_STATUS_READY: 'Terminada',
      POI_STATUS_DESCRIPTION_DRAFT:
        'Esta ficha está en preparación. La información se está verificando. Las fotos pueden no corresponder.',
      POI_STATUS_DESCRIPTION_PHOTO_AND_VIDEO_AWAITING:
        'Esta ficha está esperando fotos y pronto tendrá un video.',
      POI_STATUS_DESCRIPTION_VIDEO_AWAITING:
        'Esta ficha pronto tendrá un video.',
      POI_STATUS_DESCRIPTION_VIDEO_IN_PROGRESS:
        'El video para esta ficha está en proceso.',
      POI_STATUS_DESCRIPTION_READY:
        'Esta ficha se considera terminada. No dude en informarme de cualquier error o imprecisión.',
      POI_TYPE_LABEL: 'Tipo de punto de interés',
      POI_VILLAGE_LABEL: 'Pueblo',
      POI_CREATED_AT_LABEL: 'Fecha de creación',
      POI_UPDATED_AT_LABEL: 'Fecha de última actualización',
      SEE_ALSO: 'Ver también',
      SERVICES: 'Servicios',
      TODOS: 'Que hacer',
      TOSEES: 'Que ver',
      CYCLING: 'Pedalar',
      RAMPAGES: 'Saqueos',
      SEE_ELSEWHERE: 'Ver en otro lugar',
      AFFILIATE_LINKS: 'Enlaces de afiliados',
      AFFILIATE_LINKS_DESCRIPTION:
        'Los enlaces de afiliados son enlaces a socios comerciales. Si compras un producto a través de este enlace, Reves de Barousse recibe una comisión. El precio sigue siendo el mismo para el consumidor.',
      COMMENTS: 'Notas y comentarios',
      ADD_COMMENT: 'Agregar una nota o comentario',
      NO_COMMENT_MESSAGE: 'Aún no hay comentarios para esta entrada',
      COMMENT: 'Comentario',
      COMMENT_PLACEHOLDER: 'Ingrese su comentario',
      COMMENT_RATING: 'Puntuación',
      POST_COMMENT_SUCCESS_MESSAGE:
        'Gracias por tu comentario. Se publicará una vez que haya sido moderado.',
      ALTITUDE_PROFILE: 'Perfil altimétrico',

      // Photo
      SOME_PHOTOS: 'Algunas fotos',
      PHOTO_COORDINATES: 'Coordenadas GPS',
      PHOTO_RESOLUTION: 'Resolución',
      PHOTO_CAPTURED_AT: 'Capturada el',
      PHOTO_CAPTURED_BY: 'Capturada por',
      PHOTO_DEFINITION: 'Definición',
      MEGAPIXELS: 'megapíxeles',
      MAX_PRINT_SIZE: 'Tamaño máximo de impresión',
      MANUFACTURER: 'Fabricante',
      CAMERA_MODEL: 'Modelo de cámara',
      LENS_MAKE: 'Marca de la lente',
      FOCAL_LENGTH: 'Longitud focal',
      APERTURE: 'Apertura',
      SHUTTER_SPEED: 'Velocidad de obturación',
      ISO: 'ISO',
      ALTITUDE: 'Altitud',

      // Shop
      ADD_TO_CART: 'Agregar al carrito',
      MY_CART: 'Mi carrito',

      // Login
      LOGIN_EMAIL: 'Correo electrónico',
      LOGIN_EMAIL_PLACEHOLDER: 'Ingrese el correo electrónico',
      LOGIN_PASSWORD: 'Contraseña',
      LOGIN_PASSWORD_PLACEHOLDER: 'Ingrese la contraseña',
      LOGIN_LOGIN: 'Iniciar sesión',
      LOGIN_REGISTER: 'Registrarse',
      LOGIN_INVALID_CREDENTIALS:
        'Nombre de usuario o contraseña incorrectos. Por favor, inténtelo de nuevo.',
      FORGOTTEN_PASSWORD_REQUEST_DESCRIPTION:
        'Recibirás un correo electrónico con un enlace para restablecer tu contraseña.',
      FORGOTTEN_PASSWORD_REQUEST_SUCCESS_MESSAGE:
        'Recibirás un correo electrónico con instrucciones en unos momentos.',
      FORGOTTEN_PASSWORD_REQUEST_TITLE: 'Contraseña olvidada',
      FORGOTTEN_PASSWORD_DESCRIPTION: 'Por favor, ingresa tu nueva contraseña.',
      FORGOTTEN_PASSWORD_SUCCESS_MESSAGE:
        'Recibirás un correo electrónico con instrucciones en unos momentos.',
      FORGOTTEN_PASSWORD_TITLE: 'Restablecimiento de contraseña',
      PASSWORD_CHANGE_SUCCESS_MESSAGE:
        'La contraseña se ha cambiado correctamente.',

      // Register
      REGISTER_TITLE: 'Registrarse',
      REGISTER_SUBMIT: 'Registrarse',
      REGISTER_ERROR_FIRSTNAME: 'Por favor, ingrese su nombre',
      FIRSTNAME_PLACEHOLDER: 'Ingrese su nombre',
      REGISTER_ERROR_LASTNAME: 'Por favor, ingrese su apellido',
      LASTNAME_PLACEHOLDER: 'Ingrese su apellido',
      REGISTER_ERROR_EMAIL_ADDRESS: 'Por favor, ingrese su correo electrónico',
      REGISTER_ERROR_EMAIL_ADDRESS_YET_USED:
        'Este correo electrónico ya está en uso',
      EMAIL_ADDRESS_PLACEHOLDER: 'Ingrese su correo electrónico',
      REGISTER_ERROR_PASSWORD:
        'Al menos 8 caracteres incluyendo al menos una mayúscula, una minúscula y un carácter especial (@,$,!,%,*,?,& or .)',
      PASSWORD_PLACEHOLDER: 'Ingrese una contraseña',
      CITY_PLACEHOLDER: 'Ingrese su ciudad',
      ADDRESS_PLACEHOLDER: 'Ingrese su dirección',
      REGISTER_ERROR_ADDRESS: 'Por favor ingrese y seleccione una dirección',
      REGISTER_ERROR_PHONE: 'Por favor, ingrese su número de teléfono',
      PHONE_PLACEHOLDER: 'Ingrese su número de teléfono (facultativo)',
      REGISTER_ERROR_STREET: 'Por favor, ingrese su dirección',
      STREET_PLACEHOLDER: 'Ingrese su dirección',
      REGISTER_ERROR_ZIPCODE: 'Por favor, ingrese su código postal',
      ZIPCODE_PLACEHOLDER: 'Ingrese su código postal',
      REGISTER_CONFIRMATION_TITLE: 'Confirmación de registro',
      REGISTER_CONFIRMATION_DESCRIPTION:
        '¡Gracias por registrarte! Se ha enviado un correo electrónico de confirmación. Por favor, comprueba tu bandeja de entrada y haz clic en el enlace de confirmación para validar tu registro.',
      REGISTER_ERROR_ACTIVATING_ACCOUNT:
        'Error al activar la cuenta. Por favor, inténtelo de nuevo más tarde.',
      REGISTER_VALIDATION_TITLE: 'Validación de Registro',
      REGISTER_ACTIVATING_SUCCESS: '¡Cuenta activada con éxito!',
      REGISTER_ACTIVATING_IN_PROGRESS: 'Activando cuenta...',
      CAPTCHA_ERROR: 'Por favor, marque la casilla.',

      // Contact
      MESSAGE: 'Mensaje',
      MESSAGE_PLACEHOLDER: 'Ingresa tu mensaje',
      CONTACT_ERROR_MESSAGE:
        'Por favor, ingrese un mensaje (mínimo 20 caracteres)',
      MESSAGE_SENT: 'Su mensaje ha sido enviado',
      SELECT_AUTOCOMPLETE_MESSAGE:
        'Seleccionar una sugerencia de autocompletado',

      ERROR_EMPTY_COMMENT: 'Por favor, ingrese una calificación y/o un mensaje',
      SUCCESS_CREATED_COMMENT:
        'Su comentario ha sido guardado y aparecerá una vez validado',
      SUCCESS_RATING: 'Su calificación ha sido guardada',

      // Events
      EVENTS: 'Eventos',
      START_DATE: 'Fecha de inicio',
      END_DATE: 'Fecha de fin',
      FROM_DATE: 'Del ',
      TO_DATE: ' al ',
      FILTER_BY_DATE: 'Filtrar por fecha',

      // Mountain bike page
      POINTS_TITLE: 'Algunos puntos útiles',
      MTB_POINTS_PHYSICALLY_DEMANDING:
        'Los caminos de Barousse son físicamente exigentes, el ciclismo de montaña con asistencia eléctrica es una solución a menudo interesante.',
      POINTS_RESPECT_ECOSYSTEM: 'Respeto el frágil ecosistema del valle.',
      POINTS_RESPECT_PEOPLE: 'Respeto a la gente de Barousse.',
      MTB_POINTS_KNOW_RULES:
        'Conozco las reglas para los caminantes en los pastos.',
      MTB_POINTS_PEDESTRIAN_PRIORITY:
        'Doy prioridad a los peatones. Si me encuentro con jinetes, me bajo de la bicicleta.',
      MTB_POINTS_SAFETY_AVOID_SOLO:
        'Pienso en mi seguridad, evito andar solo y controlo mi velocidad. La montaña es hostil y una caída grave puede ocurrir rápidamente, incluso a los practicantes regulares, incluso a baja velocidad.',
      MTB_POINTS_SAFETY_WEAR_GEAR:
        'Pienso en mi seguridad, uso guantes largos, un casco. Para prácticas más intensas, añado rodilleras, coderas, protector de espalda y un casco integral.',
      MTB_POINTS_SAFETY_PHONE:
        'Pienso en mi seguridad y aunque la cobertura de red es parcial en Barousse, llevo mi teléfono, completamente cargado, en una bolsa impermeable.',
      MTB_POINTS_SAFETY_AVOID_ROADS:
        'Pienso en mi seguridad, evito las carreteras pavimentadas siempre que sea posible, Barousse está lleno de caminos de todo tipo.',
      MTB_POINTS_SAFETY_AVOID_DEPARTMENTAL:
        'Pienso en mi seguridad, evito pedalear en la carretera departamental que va de Sarp a Mauléon-Barousse. Está muy transitada y es propensa a accidentes, los límites de velocidad (ya demasiado permisivos) no se respetan bien.',
      MTB_POINTS_SAFETY_TRAIL_CONDITION:
        'Pienso en mi seguridad, los caminos en Barousse se degradan con el tiempo, a veces peligrosamente. Puedo informar cualquier problema a través del formulario web.',
      MTB_POINTS_SAFETY_FOREST:
        'Pienso en mi seguridad, los bosques de Barousse han sido abandonados a lo largo de los siglos, muchos edificios están o pronto estarán en ruinas, y muchos caminos se han convertido en callejones sin salida.',
      LESS_THAN_11KM: 'Menos de 11km',
      FROM_11_TO_20KM: 'De 11 a 20km',
      FROM_21_TO_40KM: 'De 21 a 40km',
      MORE_THAN_40KM: 'Más de 40km',
      ELEVATION_GAIN: 'Desnivel positivo',
      LESS_THAN_100M: 'Menos de 100m',
      FROM_101_TO_250M: 'De 101 a 250m',
      FROM_251_TO_600M: 'De 251 a 600m',
      MORE_THAN_600M: 'Más de 600m',
      PATH_TYPE: 'Tipo de camino',
      STABILIZED_PATH: 'Camino estabilizado, posiblemente pavimentado',
      DIRT_OR_GRASS_PATH:
        'Camino de tierra o hierba (lo suficientemente ancho para un vehículo)',
      NARROW_PATH: 'Camino estrecho (pista única)',
      TECHNIQUE: 'Técnica',
      NO_SPECIAL_TECHNIQUE: 'No requiere técnica especial',
      BASIC_MOUNTAIN_BIKING_SKILLS:
        'Requiere habilidades básicas de ciclismo de montaña. Presencia de pequeños obstáculos, pocos y no muy difíciles (surcos, piedras, zonas húmedas) en la ruta',
      ADVANCED_MOUNTAIN_BIKING_SKILLS:
        'Requiere habilidades avanzadas de ciclismo de montaña. Muchos obstáculos a superar en la ruta',
      EXPERT_MOUNTAIN_BIKING_SKILLS:
        'Requiere un dominio perfecto de todas las técnicas de ciclismo de montaña. Ruta muy exigente con zonas de trial en muchas secciones, descensos o ascensos empinados',
      TOTAL_POINTS: 'Total',
      TRAIL_COLOR: 'Color de la ruta',
      FROM_4_TO_5_POINTS: 'De 4 a 5 puntos',
      FROM_6_TO_8_POINTS: 'De 6 a 8 puntos',
      FROM_9_TO_12_POINTS: 'De 9 a 12 puntos',
      FROM_13_TO_15_POINTS: 'De 13 a 15 puntos',

      // Climbing page
      CLIMBING_POINTS_DANGER:
        'La escalada en sitios naturales en Barousse es una actividad peligrosa. Para practicar de manera segura, infórmese y, si es necesario, hágase guiar por profesionales cualificados.',

      // Hiking page
      HIKING_POINTS_PHYSICALLY_DEMANDING:
        'Algunos senderos de Barousse son físicamente exigentes, asegúrate de elegir una ruta que se ajuste a tu nivel de forma física.',
      HIKING_POINTS_TECHNICALLY_DEMANDING:
        'Algunos senderos de Barousse son técnicamente exigentes, asegúrate de elegir una ruta que se ajuste a tus habilidades técnicas.',
      HIKING_POINTS_DANGER:
        'Algunos senderos de Barousse son peligrosos y a veces tristemente mortales: caídas de piedras, acantilados, nieve helada, abismos, jabalíes, osos. La montaña puede ser hostil, mantente vigilante en todo momento.',
      HIKING_POINTS_PHONE:
        'Sal con tu teléfono completamente cargado, aunque la cobertura telefónica solo cubra una parte de Barousse.',

      // POI technical sheet
      POI_TYPE_CLASSIFICATION_TITLE: 'Clasificación de los recorridos',
      POI_TYPE_MOUNTAIN_BIKING_PAGE_CLASSIFICATION_DESCRIPTION:
        'Clasificación inspirada en las recomendaciones de la Federación Francesa de Ciclismo.',
      ELEVATION_GAIN_LABEL: 'Ganancia de Elevación',
      ELEVATION_LOSS_LABEL: 'Pérdida de Elevación',
      DISTANCE_LABEL: 'Distancia',
      EQUIVALENT_KM_LABEL: 'Km-esfuerzos',
      TECHNICITY_LABEL: 'Dificultad Técnica',
      SURFACE_TYPE_LABEL: 'Tipo de camino',
      SURFACE_LABEL: 'Superficie',
      LEVEL_LABEL: 'Clasificación',
      ALTITUDE_LABEL: 'Altitud',
      ALTITUDE_MAX_LABEL: 'Altitud Máxima',
      ALTITUDE_MIN_LABEL: 'Altitud Mínima',
      GREEN: 'Verde',
      BLUE: 'Azul',
      RED: 'Rojo',
      BLACK: 'Negro',
      EASY: 'Fácil',
      MEDIUM: 'Intermedio',
      HARD: 'Difícil',
      VERY_HARD: 'Muy Difícil',
      GRAVEL_PATH: 'Camino de Grava',
      DIRT_PATH: 'Camino de Tierra',
      SINGLETRACK: 'Sendero',

      // WIldlife
      BIRD_OF_PREY: 'Ave de rapiña',
      BIRD: 'Pájaro',
      DOMESTIC_ANIMAL: 'Animal doméstico',
      WILD_ANIMAL: 'Animal salvaje',
      INSECT: 'Insecto',
      INVERTEBRATE: 'Invertebrado',
      BUTTERFLY: 'Mariposa',
      AQUATIC_ANIMAL: 'Animal acuático',
      TYPE: 'Tipo',

      POI_TYPE_ACCOMODATION_PAGE_TITLE: 'Alojamientos en Barousse',
      POI_TYPE_ACCOMODATION_PAGE_DESCRIPTION:
        'El valle se revela con el paso de los días y las noches. Gallos, campanas, hojas al viento, murmullos de animales… y a veces el silbido del pastor. Hay que darle tiempo para escucharla, y luego comprenderla',
      POI_TYPE_ACCOMODATION_PAGE_DETAILS:
        'Para sentir de verdad la atmósfera única y preservada del valle de Barousse, hay que tomarse el tiempo… y quedarse unas noches. Así se revela otra faceta del valle: los sonidos nocturnos de los búhos, rapaces, ciervos y una fauna discreta pero presente. Y al amanecer, son los gallos, las campanas y los cantos de los pájaros los que marcan el ritmo.', // Aquí encontrarás una selección de alojamientos que combinan confort, autenticidad y compromiso local. Nuestra elección se basa en tres criterios: - Que el alojamiento esté presente en Booking.com, lo que permite a Rêves de Barousse recibir una comisión del sobre el importe de la reserva. El precio para ti no cambia, pero tu estancia nos apoya. - Una puntuación media superior a 8/10, como garantía de calidad y satisfacción. - Y sobre todo, una implicación en la preservación y promoción del patrimonio local: estos alojamientos son a menudo el fruto de renovaciones apasionadas de edificaciones típicas de la Barousse. Al elegir dormir aquí, contribuyes a mantener viva esta tierra, su naturaleza y su historia, e inspiras a otros amantes de la restauración del frágil patrimonio arquitectónico del valle.',

      POI_TYPE_VILLAGE_PAGE_TITLE: 'Los pueblos de Barousse',
      POI_TYPE_VILLAGE_PAGE_DESCRIPTION:
        'Tejida con piedra y madera, la crónica de hombres en simbiosis con la naturaleza—sus aguas, sus criaturas, su invierno y el desgaste de los siglos',
      POI_TYPE_VILLAGE_PAGE_DETAILS:
        'El murmullo de las aguas se funde con el repique de campanas, el cloqueo de las gallinas, el balido de las ovejas, el mugido de las vacas y el grito de las rapaces.\n' +
        'En esta sinfonía, viviendas de piedra y madera se mecen bajo una corona de verdor.\n' +
        'Entre naturaleza y memoria, estos pueblos te invitan a descubrir un patrimonio siempre en movimiento, forjado por el hombre y los elementos',

      POI_TYPE_WILDLIFE_PAGE_TITLE: 'La fauna de Barousse',

      POI_TYPE_WILDLIFE_PAGE_DETAILS:
        'La Barousse se abre como una invitación discreta, un umbral entre el mundo humano y la naturaleza salvaje.\n' +
        'En el corazón del valle, alrededor de los antiguos pueblos de piedra, la naturaleza florece en toda su diversidad. Los bosques antiguos extienden sus brazos verdes, refugio de lechuzas comunes, majestuosos azores y milanos reales que giran en elegantes círculos en el cielo. En los prados, ovejas y caballos pastan tranquilamente, mientras las vacas de los queseros mantienen una herencia pastoral milenaria.\n' +
        'Las alturas de la Barousse, donde el aire se vuelve más fino y el silencio ocupa todo su espacio, albergan tesoros de biodiversidad: abundan los cérvidos, los quebrantahuesos planean sobre los acantilados del Tourroc y, a veces, la sombra fugaz de un oso cruza los valles escarpados. Allí arriba, pequeños pájaros como el reyezuelo y el herrerillo animan el sotobosque, mientras las mariposas pintan manchas vivas en los claros.\n' +
        'Las aguas vivas de ríos y lagos acogen a la trucha del Ourse, la discreta nutria e incluso el Desman de Pyrénées, testigos silenciosos de un equilibrio frágil. En las orillas, la garza real vigila pacientemente, mientras los cisnes se deslizan majestuosamente sobre las aguas tranquilas del lago de Loures-Barousse.\n' +
        'Cada especie, desde la más pequeña hasta la más imponente, compone la sinfonía viva de la Barousse. Desde el canto de los zorzales hasta la discreción de la marta, desde la patrulla vigilante de los perros pastores hasta los pasos ligeros del mirlo acuático, este territorio es un mundo donde la naturaleza dialoga con el hombre.\n' +
        'Esta sección te invita a conocer a estos habitantes del valle, a comprender su papel y a compartir su historia. Porque impregnarse de la Barousse es también aprender a protegerla, para que mañana estas maravillas sigan vibrando al ritmo de las estaciones.',

      POI_TYPE_WILDLIFE_PAGE_DESCRIPTION:
        'Conocer el ecosistema de la Barousse, y en particular su rica fauna, es el primer paso esencial para comprender toda su profundidad y pensar con cuidado en su futuro.',

      POI_TYPE_HISTORY_PAGE_TITLE: 'Historia de la Barousse',
      POI_TYPE_HISTORY_PAGE_DETAILS:
        'La geografía convirtió a la Barousse en un valle culturalmente aislado. Como resultado, tiene su propia historia, influenciada por los intercambios pero sobre todo por el ecosistema en el que se integra',
      POI_TYPE_HISTORY_PAGE_DESCRIPTION:
        'Conocer y comprender el pasado para leer mejor el presente y, sobre todo, trazar el futuro',
      HISTORY: 'Historia',
      POI_TYPE_CLIMBING_PAGE_TITLE: 'Escalada en Barousse',
      POI_TYPE_CLIMBING_PAGE_DESCRIPTION:
        'El valle de Barousse, con sus acantilados de piedra caliza, ofrece numerosas rutas para todos los niveles en la calma de la naturaleza intacta.',
      POI_TYPE_CLIMBING_PAGE_DETAILS:
        'El valle de Barousse, con sus acantilados de piedra caliza esculpidos por el tiempo, es un paraíso para los escaladores. Algunas paredes han sido equipadas por apasionados, ofreciendo rutas para todos los niveles. El esfuerzo se mezcla con el asombro y la serenidad de la naturaleza preservada. Escala, respira y déjate seducir por la magia de la roca y el cielo.',
      POI_TYPE_HIKING_PAGE_TITLE: 'Senderismo en Barousse',
      POI_TYPE_HIKING_PAGE_DETAILS:
        'En Barousse, el senderismo se convierte en un paseo entre cielo y tierra, donde cada paso revela un panorama único. Los hermosos picos y crestas ofrecen balcones excepcionales sobre valles profundos y las llanuras lejanas, un verdadero espectáculo pirenaico.\n' +
        '\n' +
        'Los senderos son numerosos y variados, adecuados para todos los niveles, desde paseos suaves hasta ascensos más exigentes. Cada ruta es una invitación al descubrimiento, en un entorno preservado donde la naturaleza reina suprema.\n' +
        '\n' +
        'A lo largo del camino, encontrarás encantadores pueblos construidos en piedra y madera, con campanarios fieles, antiguos lavaderos, plazas tranquilas y estrechas calles empinadas. Lugares donde el tiempo parece suspendido y la historia se lee en cada muro.\n' +
        '\n' +
        'Aquí, el senderismo es una mezcla de esfuerzo y maravilla, soledad y encuentros, deporte y contemplación. En Barousse, cada sendero es una ventana abierta a la belleza pura de los Pirineos y al alma de sus pueblos',
      POI_TYPE_HIKING_PAGE_DESCRIPTION:
        'Descubre los senderos de Barousse para una experiencia natural excepcional.',

      POI_TYPE_MOUNTAIN_BIKING_PAGE_TITLE: 'Barousse en bicicleta de montaña',
      POI_TYPE_MOUNTAIN_BIKING_PAGE_DETAILS:
        'La Barousse se presta bien para la práctica del BTT. Por la cantidad y la variedad de caminos disponibles, alejados del tráfico, así como por la biodiversidad y la belleza de los paisajes. Aquí recopilamos algunos recorridos de diversas dificultades, en casi todos los sectores del valle',
      POI_TYPE_MOUNTAIN_BIKING_PAGE_DESCRIPTION:
        'De pendientes, de agua y de caminos olvidados',

      POI_TYPE_PICNIC_PAGE_TITLE: 'Picnic en Barousse',
      POI_TYPE_PICNIC_PAGE_DETAILS:
        'Aquí, la pausa del mediodía se convierte en un instante suspendido. Al borde del bosque, junto a un río que canta o frente a las crestas de los Pirineos, la Barousse ofrece mil rincones secretos donde extender un mantel y dejar que el tiempo se detenga.\n' +
        '\n' +
        'A su alrededor: praderas ondulantes, ruinas cubiertas de musgo, bosques centenarios y vuelos de rapaces en el cielo azul profundo. Con un poco de suerte, un ciervo o una corza cruzará su mirada — furtivo, silencioso, como un guiño de la montaña.\n' +
        '\n' +
        '¿Y en la cesta? Productos del valle, sencillos y auténticos. Un zumo de manzana fresco, queso de Sost, pan crujiente, miel dorada y algunos dulces del pastelero de Mauléon. Cada bocado cuenta una historia del terruño, cada sabor prolonga el paseo.\n' +
        '\n' +
        'Ya sea en familia, en pareja o entre amigos, el picnic se convierte en un arte de vivir, un homenaje a la lentitud y a la belleza natural. En Barousse, comer al aire libre es volver a lo esencial',
      POI_TYPE_PICNIC_PAGE_DESCRIPTION:
        'Disfruta de las numerosas áreas de picnic en Barousse para un momento de relajación al aire libre.',

      POI_TYPE_ROAD_CYCLING_PAGE_TITLE:
        'Barousse en bicicleta de carretera y gravel',
      POI_TYPE_ROAD_CYCLING_PAGE_DETAILS:
        'El valle de Barousse se abre a los ciclistas como un jardín secreto. Desde la entrada en el pueblo de Sarp (472 m), la carretera serpentea entre prados y pueblos que parecen detenidos en el tiempo. Se atraviesan Gembrie, Mauléon-Barousse, Ferrère y otras aldeas escondidas entre los pliegues de la montaña, arrulladas por el canto del río Ourse. Luego comienza la subida hacia el cielo: el puerto de Balès (1755 m), majestuoso y solitario — kilómetros de ascenso lejos del mundo, rodeados de bosques, arroyos y, a menudo, del paso silencioso de los ciervos.\n' +
        '\n' +
        'Pero la Barousse no se resume en este puerto mítico. El valle está lleno de carreteras olvidadas, caminos forestales y pequeños recorridos que merecen cada pedalada. El macizo de Hourmigué, por ejemplo, ofrece panoramas impresionantes del Pic du Gar, las crestas del Gouhouroun, y los valles gemelos de los ríos Ourse de Sost y Ourse de Ferrère.\n' +
        '\n' +
        'La subida de los puertos de Mortis, luego Chérach, y finalmente el puerto de la Géladiou — bordeada de antiguas canteras — ofrece desafíos salvajes a quienes se atreven a salir de los caminos trillados.\n' +
        '\n' +
        'En este valle hay poco tráfico. Solo el canto de los pájaros, el susurro del viento entre las ramas, el aroma del sotobosque y el encanto intacto de los pueblos. En bicicleta gravel, la experiencia es aún más inmersiva, entre senderos ocultos y bajadas aventureras.\n' +
        '\n' +
        'En este valle preservado, la bicicleta se convierte en un medio de escucha y descubrimiento. Un paréntesis natural, tanto deportivo como contemplativo',
      POI_TYPE_ROAD_CYCLING_PAGE_DESCRIPTION:
        'Bosques profundos y pueblos olvidados, cada ascenso es una escapada hacia el silencio y la belleza salvaje de los Pirineos.',
      ROAD_CYCLING_POINTS_PHYSICALLY_DEMANDING_ES:
        'Las rutas de ciclismo de carretera y gravel en Barousse son físicamente exigentes, las bicicletas de carretera eléctricas pueden ser a menudo una solución interesante.',

      UP_TO_15_EQUIVALENT_KM: 'Hasta 15 km-esfuerzo',
      FROM_15_TO_30_EQUIVALENT_KM: 'De 15 a 30 km-esfuerzo',
      FROM_30_TO_60_EQUIVALENT_KM: 'De 30 a 60 km-esfuerzo',
      MORE_THAN_60_EQUIVALENT_KM: 'Más de 60 km-esfuerzo',
      UP_TO_30_EQUIVALENT_KM: 'Hasta 30 km-esfuerzo',
      FROM_60_TO_90_EQUIVALENT_KM: 'De 60 a 90 km-esfuerzo',
      MORE_THAN_90_EQUIVALENT_KM: 'Más de 90 km-esfuerzo',

      POI_TYPE_TRAIL_PAGE_TITLE: 'Rutas de Barousse',
      POI_TYPE_TRAIL_PAGE_DETAILS:
        'Ya sea para una competición organizada o para una salida en solitario, correr en Barousse es un lujo raro de naturaleza intacta. Aquí, los senderos serpentean entre bosques, praderas y crestas olvidadas, lejos del bullicio y las multitudes.\n' +
        '\n' +
        'A veces, eres tú quien sorprende al valle. Un pito real detiene su tamborileo, una cierva se queda quieta entre helechos, un rebaño te observa curioso. Los buitres planean arriba, intrigados por tu perro. Las vacas levantan la cabeza, las ovejas se apartan tranquilamente. Solo eres un invitado pasajero, discreto, jadeante, efímero.\n' +
        '\n' +
        'Bajo tus pies, la diversidad del suelo encanta cada zancada: piedras, tierra húmeda, alfombra de hojas secas, hierba suave o ramas recién caídas. Cada paso es un diálogo con el suelo vivo.\n' +
        '\n' +
        'Y luego están los demás sentidos: los aromas intensos de árboles y musgos, avivados por las lluvias recientes. Los sonidos profundos del bosque — gritos de aves rapaces, cantos de pájaros, tintineo de campanas, mugidos lejanos, o el susurro en los arbustos cuando un ciervo se escapa.\n' +
        '\n' +
        'Correr aquí es más que un esfuerzo físico. Es una inmersión, una reconexión. En Barousse, el trail es un arte discreto, entre cielo y sotobosque.',
      POI_TYPE_TRAIL_PAGE_DESCRIPTION:
        'Explora las diversas rutas de Barousse, ideales para los entusiastas de correr',

      POI_TYPE_WATER_POINT_PAGE_TITLE: 'Puntos de agua en Barousse',
      POI_TYPE_WATER_POINT_PAGE_DETAILS:
        'En Barousse, el agua es una presencia viva, discreta y esencial. Brota de las rocas, canta en los canales, cae en cascada por las laderas cubiertas de musgo. El valle rezuma humedad. Llueve a menudo, pero es una lluvia generosa, la que alimenta los bosques, sacia a los animales y refresca los pasos del caminante.\n' +
        '\n' +
        'Algunas fuentes nacen aquí y viajan lejos, hasta llevar su frescura a las llanuras del Alto Garona. La montaña da sin medida. En cada pueblo, una fuente, un grifo, un lavadero. Se bebe un agua fresca y clara, directamente nacida de las entrañas del macizo.\n' +
        '\n' +
        'Caminar por Barousse es también aprender a levantar los ojos… y a bajarlos, para encontrar un hilo de agua, escuchar un murmullo líquido, llenar la cantimplora en una fuente. El agua está en todas partes — en los arroyos, los abrevaderos, las cascadas — como un hilo invisible que une la naturaleza, los animales y las personas',
      POI_TYPE_WATER_POINT_PAGE_DESCRIPTION:
        'Descubre los puntos de agua en Barousse, perfectos para una pausa refrescante.',

      POI_TYPE_RAMPAGE_PAGE_TITLE: 'Saqueo en Barousse',
      POI_TYPE_RAMPAGE_PAGE_DETAILS:
        'El tiempo pasa, Barousse avanza. No siempre en la dirección correcta, lamentablemente. La modernidad no siempre armoniza con el pesado legado de Barousse. A veces podríamos reparar. A veces es demasiado tarde, pero aprendamos la lección para prevenir futuros destrozos. No, no necesariamente era mejor antes, pero lo que era mejor entonces conviene protegerlo, incluso si a veces significa perder comodidad o conveniencia. Este es el trabajo respetable que a veces se encuentra entre británicos, italianos o suizos, en Provenza, en el País Vasco, pero también a veces en ciertos pueblos de Barousse.',
      POI_TYPE_RAMPAGE_PAGE_DESCRIPTION: 'Los estragos de la locura humana',

      POI_TYPE_CURIOSITY_PAGE_TITLE: 'Cultura y curiosidades en Barousse',
      POI_TYPE_CURIOSITY_PAGE_DETAILS:
        'Siglos de presencia humana, milenios para la naturaleza. Una convivencia rica en intereses variados. En el camino que nos lleva de la barbarie a la civilización.',
      POI_TYPE_CURIOSITY_PAGE_DESCRIPTION: 'De la naturaleza y los hombres',

      POPULATION: 'Población',
      POPULATION_GROWTH: 'Evolución de la población',
      YEAR: 'Año',
    },
  },
}

i18n.use(initReactI18next).init({
  resources,
  lng: 'fr',
  fallbackLng: 'fr',
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
